import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import CheckInStatusPresets from "../components/CheckInStatusPresets";
import {
  STATUS_OPTIONS,
  statusLabel,
  subStatusForStatus,
  subStatusLabel,
  subStatusOptions,
} from "../utils/webcheckinStatus";
import "./CheckInDetails.css";
import {
  fetchTicketData,
  addPassenger,
  triggerBrowserUserForCheckIn,
  updateCheckInStatus,
  deleteUserTicket,
  cancelUserTicket,
  deleteTicketDocument,
  updateIndividualPassengerData,
  deletePassengerData,
  fetchEmailTextData,
  fetchParsedEmailText,
  fetchBrowserUseCheckIn,
} from "../services/api";
import { useTicketContext } from "../context/TicketContext";
import { Input } from "../components/ui/input";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { getStatusIndicatorColor, getStatusTextColor, getStatusTailwindClasses } from "../utils/statusUtils";
import { getTicketSourceTailwindClasses, normalizeTicketSource } from "../utils/ticketSourceUtils";
// import { useAuth } from "../context/AuthContext";

import { ClipboardCopyIcon, EnvelopeClosedIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import UserPreferences from '../components/UserPreferences';
import PassengerDetails from '../components/PassengerDetails';
import RadixDialog from '../components/ui/RadixDialog';
import RadixButton from '../components/ui/RadixButton';
import { ADMIN_API_BASE_URL } from '../config/api';

// Notification preview images mapping (S3 URLs)
const NOTIFICATION_PREVIEW_IMAGES = {
  'FAILED_CHECKIN': 'https://hh-boarding-pass.s3.ap-south-1.amazonaws.com/file_uploads/622_1772518112793_checkin_failed.jpg',
  'SUCCESSFUL_CHECKIN': 'https://hh-boarding-pass.s3.ap-south-1.amazonaws.com/file_uploads/622_1772518060468_checkin_completed.jpg',
  'SEAT_PURCHASE': 'https://hh-boarding-pass.s3.ap-south-1.amazonaws.com/file_uploads/622_1772518167288_seat_purchase.jpg',
  'OPT_IN_CHECKIN': 'https://hh-boarding-pass.s3.ap-south-1.amazonaws.com/file_uploads/622_1772518144888_checkin_optin.jpg',
  'BOARDING_PASS': 'https://hh-boarding-pass.s3.ap-south-1.amazonaws.com/file_uploads/622_1772518193495_send_boardingpass.jpg',
};

dayjs.extend(utc);

const MISSING_INFO_MESSAGE_OPTIONS = [
  "Missing PNR",
  "Missing Passport",
  "Missing Phone Number",
  "Missing Date of Birth",
  "Missing Visa",
];

const normalizeSubStatusValue = (value) => {
  const trimmed = (value || "").trim();
  return trimmed ? trimmed.toUpperCase() : "NONE";
};

// const getAuthToken = () => {
//   return localStorage.getItem("authToken");
// };



// Component
const CheckInDetailsPage = () => {
  const { ticket_id, user_id } = useParams();
  // const params = useParams();

  console.log("Ticket ID:", ticket_id);
  console.log("User ID:", user_id);
  const navigate = useNavigate();
  // const location = window.location.pathname;
  // Get the source tab from URL query parameters
  const queryParams = new URLSearchParams(window.location.search);
  const sourceTab = queryParams.get('source');
  console.log("Source tab:", sourceTab);

  const { setTicketInfo } = useTicketContext();
  // const { user, logout } = useAuth();

  // Remove hardcoded user info - using auth context instead
  // const [userInfo, setUserInfo] = useState({
  //   name: "Admin User",
  //   email: "admin@havahavai.com"
  // });

  // Use the ticket_id from the URL
  // const ticket_id = urlTicketId;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const [emailTextData, setEmailTextData] = useState(null);
  const [emailTextLoading, setEmailTextLoading] = useState(false);
  const [showEmailTextModal, setShowEmailTextModal] = useState(false);
  const [parsedEmailTextData, setParsedEmailTextData] = useState(null);
  const [parsedEmailTextLoading, setParsedEmailTextLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("");
  const [reason, setReason] = useState("");
  const [showReasonDialog, setShowReasonDialog] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [passengerToDelete, setPassengerToDelete] = useState(null);
  const [showDeleteTicketConfirmation, setShowDeleteTicketConfirmation] = useState(false);
  const [showCancelTicketConfirmation, setShowCancelTicketConfirmation] = useState(false);
  const [showDeleteDocumentConfirmation, setShowDeleteDocumentConfirmation] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("flightDetails");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  const [selectedFiles, setSelectedFiles] = useState({});
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [showNotificationMenu, setShowNotificationMenu] = useState(false);
  const [emailSyncLoading, setEmailSyncLoading] = useState(false);
  const [triggerBrowserLoading, setTriggerBrowserLoading] = useState(false);
  const notificationMenuRef = useRef(null);
  const statusMenuRef = useRef(null);
  const [editingPnr, setEditingPnr] = useState(false);
  const [pnrValue, setPnrValue] = useState("");
  const [scheduledHours, setScheduledHours] = useState("");
  const [editingPassenger, setEditingPassenger] = useState(null);
  const [passengerFormData, setPassengerFormData] = useState({
    first_name: "",
    last_name: "",
    seat: "",
    meal_preference: "",
    baggage_allowance: {
      checkin: "",
      cabin: "",
    },
  });
  const [editingUserDetails, setEditingUserDetails] = useState(false);
  const [userFormData, setUserFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    passport: "",
    nationality: "",
    passport_expiry: "",
    countryCode: "",
    phoneNumber: "",
  });
  const [seatNumber, setSeatNumber] = useState("");
  const [currency, setCurrency] = useState("");
  const [amount, setAmount] = useState("");
  const [showSeatPurchaseForm, setShowSeatPurchaseForm] = useState(false);

  const [showStatusUpdateDialog, setShowStatusUpdateDialog] = useState(false);
  const [selectedStatusForUpdate, setSelectedStatusForUpdate] = useState(null);
  const [checkinSubStatusValue, setCheckinSubStatusValue] = useState("");
  const [checkinMessageValue, setCheckinMessageValue] = useState("");
  const [selectedMissingInfoMessages, setSelectedMissingInfoMessages] = useState([]);

  const [selectedFlightId, setSelectedFlightId] = useState(null);
  const [showFlightSelection, setShowFlightSelection] = useState(false);
  const [showAddPassengerForm, setShowAddPassengerForm] = useState(false);
  const [flightSelectionAction, setFlightSelectionAction] = useState(null); // 'upload' or 'addPassenger'
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const [addPassengerFormData, setAddPassengerFormData] = useState({
    firstName: "",
    lastName: "",
    seat: "",
    meal: "",
    checkinBaggage: "",
    cabinBaggage: "",
    sequenceNumber: "",
  });
  const [browserUseStepsData, setBrowserUseStepsData] = useState([]);
  const [, setBrowserUseStepsLoading] = useState(false);

  const handleNotificationMenuClick = () => {
    setShowNotificationMenu(!showNotificationMenu);
  };

  const handleSubStatusFieldChange = (value) => {
    setCheckinSubStatusValue(value);

    if (!value?.trim() || value !== "MISSING_INFO") {
      setCheckinMessageValue("");
      setSelectedMissingInfoMessages([]);
    }
  };

  const handleMissingInfoMessageChange = (option) => {
    setSelectedMissingInfoMessages((prev) => {
      if (prev.includes(option)) {
        return prev.filter((item) => item !== option);
      } else {
        return [...prev, option];
      }
    });
  };

  const handleNotificationMenuClose = () => {
    setShowNotificationMenu(false);
  };

  // Handle click outside to close notification dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationMenuRef.current &&
        !notificationMenuRef.current.contains(event.target)
      ) {
        setShowNotificationMenu(false);
      }
    };

    if (showNotificationMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotificationMenu]);

  // Handle click outside to close status dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        statusMenuRef.current &&
        !statusMenuRef.current.contains(event.target)
      ) {
        setShowStatusMenu(false);
      }
    };

    if (showStatusMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showStatusMenu]);

  useEffect(() => {
    if (ticketData) {
      setCheckinSubStatusValue(ticketData.checkin_sub_status || "");
      setCheckinMessageValue(ticketData.checkin_message || "");
      // Initialize selectedMissingInfoMessages if sub-status is MISSING_INFO
      if (ticketData.checkin_sub_status === "MISSING_INFO" && ticketData.checkin_message) {
        setSelectedMissingInfoMessages(
          ticketData.checkin_message.split(",").map((m) => m.trim()).filter(Boolean)
        );
      } else {
        setSelectedMissingInfoMessages([]);
      }
    }
  }, [ticketData]);

  useEffect(() => {
    if (
      normalizeSubStatusValue(checkinSubStatusValue) === "MISSING_INFO" &&
      !checkinMessageValue
    ) {
      setCheckinMessageValue(MISSING_INFO_MESSAGE_OPTIONS[0]);
    }
  }, [checkinSubStatusValue, checkinMessageValue]);

  // Helper function to get tab content
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };



  // Helper function to show toast message
  const showToastMessage = (message, type = "success") => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  // Helper function to copy text to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        showToastMessage("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        showToastMessage("Failed to copy to clipboard", "error");
      });
  };

  // Function to handle file upload
  const handleUpload = async (id, fileType, flightId) => {
    console.log("handleUpload called with:", { id, fileType, flightId });
    console.log("selectedFiles:", selectedFiles);
    console.log("user_id:", id);

    // Check if id is undefined or null
    if (!id) {
      console.log("Error: user_id is undefined or null");
      showToastMessage("Error: User ID is missing", "error");
      return;
    }

    // Check if file is selected
    if (!selectedFiles[id] || !selectedFiles[id][fileType]) {
      console.log("No file selected");
      showToastMessage("Please select a file first", "error");
      return;
    }

    // Check if document type is selected for ticket documents
    if (fileType === "ticket_document" && !selectedDocumentType) {
      console.log("No document type selected");
      showToastMessage("Please select a document type first", "error");
      return;
    }

    console.log("userid in doc upload is: ", id);
    console.log("flight id in doc upload is: ", flightId);
    console.log("file to upload:", selectedFiles[id][fileType]);

    try {
      setUploadLoading(true);
      const file = selectedFiles[id][fileType];
      const formData = new FormData();
      formData.append("file", file);

      let documentType = "";
      if (fileType === "boarding_pass") {
        documentType = "Boarding_Pass";
      } else if (fileType === "ticket_document") {
        // Use the selected document type from the dropdown
        documentType = selectedDocumentType;
      }

      console.log("document type is: ", documentType);

      formData.append("documentType", documentType);
      let url = `${ADMIN_API_BASE_URL}/uploadTicketDocuments?userId=${id}&ticketId=${ticketData.ticket_id}`;
      if (flightId) {
        url = `${ADMIN_API_BASE_URL}/uploadTicketDocuments?userId=${id}&ticketId=${ticketData.ticket_id}&flightId=${flightId}`;
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setDialogMessage(
          data.message ||
            `${documentType.replace("_", " ")} uploaded successfully`
        );
        setDialogType("success");
        // Refresh the page to show the updated document
        window.location.reload();
      } else {
        setDialogMessage(
          data.message || `Failed to upload ${documentType.replace("_", " ")}`
        );
        setDialogType("error");
      }

      setOpenDialog(true);
    } catch (error) {
      console.error(`Error uploading ${fileType}:`, error);
      setDialogMessage(
        `Error uploading ${fileType.replace("_", " ")}. Please try again.`
      );
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
    }
  };

  // Function to send notification with specified type
  const sendNotification = async (type, reasonText = "") => {
    try {
      setUploadLoading(true);
      handleNotificationMenuClose();

      let url = `${ADMIN_API_BASE_URL}/triggerCheckinNotification?userId=${user_id}&ticketId=${ticketData.ticket_id}&type=${type}`;

      // Add reason parameter for failed check-in notification
      if (type === "FAILED_CHECKIN" && reasonText) {
        url += `&reason=${encodeURIComponent(reasonText)}`;
      }

      // Add seat purchase parameters
      if (type === "SUCCESSFUL_SEAT_PURCHASE_WITH_PAYMENT") {
        url += `&seatNumber=${encodeURIComponent(
          seatNumber
        )}&currency=${encodeURIComponent(currency)}&amount=${encodeURIComponent(
          amount
        )}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
        },
      });

      const data = await response.json();
      setDialogMessage(
        data.message ||
          `${type.replace(/_/g, " ")} notification sent successfully`
      );
      setDialogType("success");
      setOpenDialog(true);

      // Hide loading immediately after API call completes
      setUploadLoading(false);

      // Refresh ticket data in the background without blocking UI
      if (ticketData && ticketData.ticket_id) {
        // Use setTimeout to ensure the loading state is cleared before starting background refresh
        setTimeout(async () => {
          try {
            console.log("Refreshing ticket data after notification in background...");
            console.log("refresh data ticket_id is: ", ticketData.ticket_id);
            console.log("refresh data userid is: ", ticketData?.user_id);
            console.log("refresh data: ", ticketData);
            const refreshedData = await fetchTicketData(
              ticketData.ticket_id,
              ticketData.user_id
            );
            console.log(
              "Refreshed data:",
              JSON.stringify(refreshedData, null, 2)
            );
            setTicketData(refreshedData);
          } catch (refreshError) {
            console.error("Error refreshing ticket data:", refreshError);
          }
        }, 0);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      setDialogMessage("Error sending notification. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
      setUploadLoading(false);
    }
  };

  // Function to handle failed check-in notification
  // const handleFailedCheckInClick = () => {
  //   setShowReasonDialog(true);
  //   handleNotificationMenuClose();
  // };

  // Handle submitting the reason
  // const handleReasonSubmit = (reasonText) => {
  //   sendNotification("FAILED_CHECKIN", reasonText);
  //   setShowReasonDialog(false);
  // };

  // Handle dialog close
  // const handleDialogClose = useCallback(() => {
  //   console.log("Dialog closing, type:", dialogType, "reason:", reason);
  //   setOpenDialog(false);
  //   setDialogType("");
  // }, [dialogType, reason]);

  // Function to handle passenger deletion
  const handleDeletePassenger = async (passengerFlightId) => {
    try {
      setUploadLoading(true);

      const response = await fetch(
        `${ADMIN_API_BASE_URL}/deletePasseneger?passengerFlightId=${passengerFlightId}`,
        {
          method: "DELETE",
          headers: {
            authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Update the ticket data by removing the deleted passenger
        if (ticketData && ticketData.pax_data) {
          const updatedPassengers = ticketData.pax_data.filter(
            (passenger) => passenger.passengerFlightId !== passengerFlightId
          );

          setTicketData({
            ...ticketData,
            pax_data: updatedPassengers,
          });
        }

        setDialogMessage("Passenger deleted successfully");
        setDialogType("success");
      } else {
        setDialogMessage(data.message || "Error deleting passenger");
        setDialogType("error");
      }

      setOpenDialog(true);
    } catch (error) {
      console.error("Error deleting passenger:", error);
      setDialogMessage("Error deleting passenger. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
      setShowDeleteConfirmation(false);
      setPassengerToDelete(null);
    }
  };

  // Function to handle passenger update for PassengerDetails component
  const handleUpdatePassenger = async (passengerData) => {
    try {
      // DEBUG: Log received data from PassengerDetails component
      console.log('=== DEBUG: handleUpdatePassenger received data ===');
      console.log('passengerData:', passengerData);
      console.log('passengerData.gender:', passengerData.gender);
      console.log('passengerData.dateOfBirth:', passengerData.dateOfBirth);

      const apiData = {
        passengerId: passengerData.passengerId, // Use passenger.id as passengerId
        firstName: passengerData.firstName,
        lastName: passengerData.lastName,
        mobileNumber: passengerData.mobileNumber,
        email: passengerData.email,
        dateOfBirth: passengerData.dateOfBirth,
        gender: passengerData.gender,
        nationality: passengerData.nationality,
        countryOfResidence: passengerData.countryOfResidence
      };

      // DEBUG: Log data being sent to API
      console.log('=== DEBUG: Data being sent to updateIndividualPassengerData ===');
      console.log('apiData:', apiData);

      // Use the new INDIVIDUAL_PASSENGER API endpoint
      await updateIndividualPassengerData(apiData);

      // Refresh the ticket data
      const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error updating passenger:", error);
      throw error;
    }
  };

  // Function to handle passenger deletion for PassengerDetails component
  const handleDeletePassengerFromDetails = async (passengerFlightId) => {
    try {
      await deletePassengerData(passengerFlightId);
      // Refresh the ticket data
      const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error deleting passenger:", error);
      throw error;
    }
  };

  // Function to refresh ticket data
  const handleRefreshTicketData = async () => {
    try {
      const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error refreshing ticket data:", error);
      throw error;
    }
  };

  // Function to open delete confirmation dialog
  // const openDeleteConfirmation = (passenger) => {
  //   setPassengerToDelete(passenger);
  //   setShowDeleteConfirmation(true);
  // };

  // Function to close delete confirmation dialog
  // const closeDeleteConfirmation = () => {
  //   setShowDeleteConfirmation(false);
  //   setPassengerToDelete(null);
  // };

  // Function to handle ticket deletion
  const handleDeleteTicket = async () => {
    try {
      setUploadLoading(true);

      const result = await deleteUserTicket(Number(ticket_id), Number(user_id));

      setDialogMessage(result.message || "Ticket deleted successfully");
      setDialogType("success");
      setOpenDialog(true);

      // Navigate back to the previous page after successful deletion
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    } catch (error) {
      console.error("Error deleting ticket:", error);
      setDialogMessage("Error deleting ticket. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
      setShowDeleteTicketConfirmation(false);
    }
  };

  // Function to handle ticket cancellation
  const handleCancelTicket = async () => {
    try {
      setUploadLoading(true);

      const result = await cancelUserTicket(Number(ticket_id), Number(user_id));

      setDialogMessage(result.message || "Ticket cancelled successfully");
      setDialogType("success");
      setOpenDialog(true);

      // Refresh the ticket data to show the updated status
      const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error cancelling ticket:", error);
      setDialogMessage("Error cancelling ticket. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
      setShowCancelTicketConfirmation(false);
    }
  };

  // Function to handle document deletion
  const handleDeleteDocument = async () => {
    if (!documentToDelete || !documentToDelete.document_id) {
      showToastMessage("Cannot delete document: Missing document ID", "error");
      setShowDeleteDocumentConfirmation(false);
      return;
    }

    try {
      setUploadLoading(true);
      const result = await deleteTicketDocument(documentToDelete.document_id);

      if (result.success) {
        showToastMessage("Document deleted successfully", "success");
        // Refresh the page to show the updated documents
        const refreshData = await fetchTicketData(ticket_id, user_id);
        setTicketData(refreshData);
      } else {
        showToastMessage(result.message || "Failed to delete document", "error");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      showToastMessage(error.message || "An error occurred while deleting the document", "error");
    } finally {
      setUploadLoading(false);
      setShowDeleteDocumentConfirmation(false);
      setDocumentToDelete(null);
    }
  };

  // Fetch browser use check-in data
  useEffect(() => {
    const getBrowserUseCheckInData = async () => {
      try {
        setBrowserUseStepsLoading(true);
        console.log("Fetching browser use check-in data for user ID:", user_id, "ticket ID:", ticket_id);

        const data = await fetchBrowserUseCheckIn(user_id, ticket_id);
        console.log("Browser use check-in data:", data);

        if (data.success && Array.isArray(data.data)) {
          setBrowserUseStepsData(data.data);
        }
      } catch (err) {
        console.error("Error fetching browser use check-in data:", err);
        // Don't show error toast as this is not critical
      } finally {
        setBrowserUseStepsLoading(false);
      }
    };

    if (user_id && ticket_id) {
      getBrowserUseCheckInData();
    }
  }, [user_id, ticket_id]);

  // Fetch ticket data from API
  useEffect(() => {
    const getTicketData = async () => {
      try {
        setLoading(true);
        console.log("Fetching ticket data for ticket ID:", ticket_id);
        console.log("Fetching user data for user ID:", user_id);

        // Use the fetchTicketData function from the API service
        const data = await fetchTicketData(ticket_id, user_id);

        console.log("API Response data:", JSON.stringify(data, null, 2));

        // Log specific flight data for debugging city values
        if (data.flight_data && data.flight_data.length > 0) {
          console.log(
            "Flight data structure:",
            JSON.stringify(
              {
                departure: {
                  airport_iata:
                    data.flight_data[0].departure_data?.airport_iata,
                  country: data.flight_data[0].departure_data?.country,
                  origin_country: data.flight_data[0].origin_country,
                },
                arrival: {
                  airport_iata: data.flight_data[0].arrival_data?.airport_iata,
                  country: data.flight_data[0].arrival_data?.country,
                  destination_country: data.flight_data[0].destination_country,
                },
                isInternational:
                  data.flight_data[0].departure_data?.country &&
                  data.flight_data[0].arrival_data?.country &&
                  data.flight_data[0].departure_data.country !==
                    data.flight_data[0].arrival_data.country,
              },
              null,
              2
            )
          );
        }

        // Check boarding pass structure
        if (data.flight_data && data.flight_data.length > 0) {
          // Log boarding passes for all flights
          data.flight_data.forEach((flight) => {
            if (flight.ancillaryData && flight.ancillaryData.length > 0) {
              console.log(
                `Boarding passes for flight ${flight.id} (${flight.flight_number}):`,
                flight.ancillaryData.map(
                  (p) => p.boarding_pass_url || "No boarding pass URL"
                )
              );
            }
          });
        } else if (data.pax_data) {
          console.log(
            "Passenger data:",
            data.pax_data.map((p) => p.boarding_pass || "No boarding pass")
          );
        }

        // Check document structure
        console.log("Ticket documents:", data.ticket_documents || "None");

        setTicketData(data);

        // Share ticket data with Layout component via context
        setTicketInfo({
          pnr: data.pnr,
          checkin_status: data.checkin_status,
        });

        // Fetch email text data after ticket data is loaded (non-blocking)
        fetchEmailTextDataForTicket(ticket_id, user_id);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message || "An error occurred while fetching ticket data");
        setTicketInfo(null);
      } finally {
        setLoading(false);
      }
    };

    if (ticket_id) {
      getTicketData();
    }

    // Cleanup function to reset ticket info when component unmounts
    return () => {
      setTicketInfo(null);
    };
  }, [ticket_id, user_id, setTicketInfo]);

  // const handleViewBoardingPass = (passengerId, flightId) => {
  //   // Find the passenger with the given ID and flight ID
  //   const passenger = ticketData?.pax_data?.find((p) => p.id === passengerId && p.flight_id === flightId);
  //   if (passenger && hasBoardingPass(passenger)) {
  //     window.open(getBoardingPassUrl(passenger), "_blank");
  //   } else {
  //     showToastMessage("Boarding pass not available", "error");
  //   }
  // };

  const handleFileChange = (e, passengerId, fileType) => {
    console.log("handleFileChange called with:", { passengerId, fileType });
    console.log("Files:", e.target.files);

    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      console.log("Selected file:", file);

      setSelectedFiles((prev) => {
        const newState = {
          ...prev,
          [passengerId]: {
            ...(prev[passengerId] || {}),
            [fileType]: file,
          },
        };
        console.log("New selectedFiles state:", newState);
        return newState;
      });

      // Show the file name in a toast
      showToastMessage(`Selected file: ${file.name}`, "info");
    } else {
      console.log("No file selected");
    }
  };

  // In the flight details tab, update the boarding pass checking code to include the new API structure
  const getBoardingPassUrl = (passenger) => {
    // Check if passenger has ancillaryData with boarding_pass_url
    if (ticketData.flight_data && ticketData.flight_data.length > 0) {
      // Find the flight data that matches the passenger's flight_id
      const flightData = ticketData.flight_data.find(flight => flight.id === passenger.flight_id);

      if (flightData && flightData.ancillaryData && flightData.ancillaryData.length > 0) {
        const boardingPass = flightData.ancillaryData.find(
          (data) => data.pax_id === passenger.id
        );
        if (boardingPass && boardingPass.boarding_pass_url) {
          return boardingPass.boarding_pass_url;
        }
      }
    }

    // Fallback to direct boarding_pass or boarding_pass_url on passenger
    return passenger.boarding_pass || passenger.boarding_pass_url;
  };

  const hasBoardingPass = (passenger) => {
    return Boolean(getBoardingPassUrl(passenger));
  };

  // Function to handle boarding pass download with error handling
  const handleBoardingPassDownload = async (passenger) => {
    try {
      const url = getBoardingPassUrl(passenger);

      if (!url) {
        showToastMessage("Boarding pass not available for download", "error");
        return;
      }

      setDownloadLoading(true);
      showToastMessage("Preparing download...", "info");

      // Fetch the file as a blob to force download
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/pdf,image/*,*/*',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get the file as a blob
      const blob = await response.blob();

      // Determine file extension from content type or URL
      const contentType = response.headers.get('content-type') || '';
      let fileExtension = '.pdf'; // default

      if (contentType.includes('image/png')) {
        fileExtension = '.png';
      } else if (contentType.includes('image/jpeg') || contentType.includes('image/jpg')) {
        fileExtension = '.jpg';
      } else if (contentType.includes('image/')) {
        fileExtension = '.png'; // fallback for other image types
      } else if (url.toLowerCase().includes('.png')) {
        fileExtension = '.png';
      } else if (url.toLowerCase().includes('.jpg') || url.toLowerCase().includes('.jpeg')) {
        fileExtension = '.jpg';
      }

      // Create blob URL and download
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `boarding-pass-${passenger.first_name}-${passenger.last_name}${fileExtension}`;

      // Add to DOM temporarily and trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);

      showToastMessage("Boarding pass downloaded successfully", "success");
    } catch (error) {
      console.error("Error downloading boarding pass:", error);

      // Fallback: try the simple download method
      try {
        const url = getBoardingPassUrl(passenger);
        const link = document.createElement('a');
        link.href = url;
        link.download = `boarding-pass-${passenger.first_name}-${passenger.last_name}.pdf`;
        link.target = '_blank'; // Open in new tab as fallback

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        showToastMessage("Download initiated (may open in new tab due to CORS restrictions)", "warning");
      } catch (fallbackError) {
        console.error("Fallback download also failed:", fallbackError);
        showToastMessage("Failed to download boarding pass. Please try the 'View' button instead.", "error");
      }
    } finally {
      setDownloadLoading(false);
    }
  };

  // Add helper functions to retrieve ancillary data
  const getSeatNumber = (passenger) => {
    if (ticketData.flight_data && ticketData.flight_data.length > 0) {
      // Find the flight data that matches the passenger's flight_id
      const flightData = ticketData.flight_data.find(flight => flight.id === passenger.flight_id);

      if (flightData && flightData.ancillaryData && flightData.ancillaryData.length > 0) {
        const data = flightData.ancillaryData.find((d) => d.pax_id === passenger.id);
        return data?.seat || passenger.seat || "";
      }
    }
    return passenger.seat || "";
  };

  const getMealPreference = (passenger) => {
    if (ticketData.flight_data && ticketData.flight_data.length > 0) {
      // Find the flight data that matches the passenger's flight_id
      const flightData = ticketData.flight_data.find(flight => flight.id === passenger.flight_id);

      if (flightData && flightData.ancillaryData && flightData.ancillaryData.length > 0) {
        const data = flightData.ancillaryData.find((d) => d.pax_id === passenger.id);
        return data?.meal || passenger.meal || "";
      }
    }
    return passenger.meal || "";
  };

  const getBaggageAllowance = (passenger) => {
    let baggageInfo = { checkin: "", cabin: "" };

    if (ticketData.flight_data && ticketData.flight_data.length > 0) {
      // Find the flight data that matches the passenger's flight_id
      const flightData = ticketData.flight_data.find(flight => flight.id === passenger.flight_id);

      if (flightData && flightData.ancillaryData && flightData.ancillaryData.length > 0) {
        const data = flightData.ancillaryData.find((d) => d.pax_id === passenger.id);
        if (data) {
          baggageInfo.checkin = data.check_in_baggage || "";
          baggageInfo.cabin = data.cabin_baggage || "";
        }
      }
    }

    // Fallback to passenger direct properties if no ancillary data
    if (!baggageInfo.checkin && passenger.check_in_baggage) {
      baggageInfo.checkin = passenger.check_in_baggage;
    }
    if (!baggageInfo.cabin && passenger.cabin_baggage) {
      baggageInfo.cabin = passenger.cabin_baggage;
    }

    return baggageInfo;
  };

  // Function to fetch email text data
  const fetchEmailTextDataForTicket = async (ticketId, userId) => {
    try {
      setEmailTextLoading(true);
      console.log('Fetching email text data for ticketId:', ticketId, 'userId:', userId);

      const data = await fetchEmailTextData(ticketId, userId);
      setEmailTextData(data);

      console.log('Email text data fetched successfully:', data);
    } catch (error) {
      console.error('Error fetching email text data:', error);
      // Don't show error toast for email text data as it's not critical
      setEmailTextData(null);
    } finally {
      setEmailTextLoading(false);
    }
  };

  // Function to handle fetching parsed email text
  const handleFetchParsedEmailText = async () => {
    try {
      setParsedEmailTextLoading(true);
      console.log('Fetching parsed email text for ticketId:', ticket_id, 'userId:', user_id);

      const data = await fetchParsedEmailText(ticket_id, user_id);
      setParsedEmailTextData(data);
      setShowEmailTextModal(true);

      console.log('Parsed email text fetched successfully:', data);
    } catch (error) {
      console.error('Error fetching parsed email text:', error);
      setToastMessage('Failed to fetch email text data');
      setToastType('error');
      setShowToast(true);
      setParsedEmailTextData(null);
    } finally {
      setParsedEmailTextLoading(false);
    }
  };

  // Add logout function
  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     navigate("/login", { replace: true });
  //   } catch (error) {
  //     console.error("Error during logout:", error);
  //     alert("Logout failed. Please try again.");
  //   }
  // };

  // Function to trigger browser user for check-in
  const handleTriggerBrowserUser = async () => {
    try {
      setTriggerBrowserLoading(true);

      let scheduledTimeISO = null;

      // If hours are provided for scheduled check-in
      if (scheduledHours && parseInt(scheduledHours) > 0) {
        // Get departure time from flight data
        const flight = ticketData?.flight_data?.[0];
        const departureTime = flight?.departure_data?.planned_date || flight?.departure_date;

        if (departureTime) {
          // Calculate scheduled time as hours before departure
          const departureDate = new Date(departureTime);
          const scheduledTime = new Date(departureDate.getTime() - (parseInt(scheduledHours) * 60 * 60 * 1000));
          scheduledTimeISO = scheduledTime.toISOString();
          console.log("Scheduling check-in for:", scheduledTimeISO, "which is", scheduledHours, "hours before departure");
        } else {
          console.error("No departure time found for scheduling");
        }
      }

      const result = await triggerBrowserUserForCheckIn(user_id, ticket_id, scheduledTimeISO);

      const successMessage = scheduledTimeISO
        ? `Check-in scheduled for ${new Date(scheduledTimeISO).toLocaleString()}`
        : "Check-in flow triggered successfully";

      setDialogMessage(result.message || successMessage);
      setDialogType("success");
      setOpenDialog(true);
      const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error triggering check-in flow:", error);
      setDialogMessage("Error triggering check-in flow. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setTriggerBrowserLoading(false);
    }
  };

  // Function to update PNR
  const updatePnr = async () => {
    try {
      setUploadLoading(true);

      const response = await fetch(
        `${ADMIN_API_BASE_URL}/update`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
          },
          body: JSON.stringify({
            type: "TICKET",
            body: {
              ticketId: ticketData.ticket_id,
              pnr: pnrValue,
            },
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Update the ticket data with the new PNR
        setTicketData({
          ...ticketData,
          pnr: pnrValue,
        });

        setDialogMessage("PNR updated successfully");
        setDialogType("success");
        setEditingPnr(false);
      } else {
        setDialogMessage(data.message || "Error updating PNR");
        setDialogType("error");
      }

      setOpenDialog(true);
    } catch (error) {
      console.error("Error updating PNR:", error);
      setDialogMessage("Error updating PNR. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
    }
  };

  // Function to handle status menu click
  const handleStatusMenuClick = () => {
    setShowStatusMenu(!showStatusMenu);
  };

  // Function to handle status menu close
  const handleStatusMenuClose = () => {
    setShowStatusMenu(false);
  };

  // Function to handle status selection - show dialog instead of direct update
  const handleStatusSelection = (status) => {
    setSelectedStatusForUpdate(status);
    // Keep the current sub-status only if it goes with the new status.
    setCheckinSubStatusValue(subStatusForStatus(status, ticketData?.checkin_sub_status));
    setCheckinMessageValue(ticketData?.checkin_message || "");
    setSelectedMissingInfoMessages(
      ticketData?.checkin_message && ticketData.checkin_sub_status === "MISSING_INFO"
        ? ticketData.checkin_message.split(",").map((m) => m.trim()).filter(Boolean)
        : []
    );
    handleStatusMenuClose();
    setShowStatusUpdateDialog(true);
  };

  // Function to handle manual status update from dialog
  const handleManualStatusUpdate = async () => {
    try {
      setUploadLoading(true);
      setShowStatusUpdateDialog(false);

      const normalizedSubStatus = checkinSubStatusValue?.trim() || "";
      let normalizedMessage = "";

      if (normalizedSubStatus === "MISSING_INFO") {
        // Filter out "N/A" if user has selected actual options
        const filteredMessages = selectedMissingInfoMessages.filter(msg => msg !== "N/A");
        if (filteredMessages.length > 0) {
          normalizedMessage = filteredMessages.join(", ");
        } else {
          normalizedMessage = "N/A";
        }
      } else if (normalizedSubStatus !== "MISSING_INFO") {
        normalizedMessage = checkinMessageValue?.trim() || "";
      }

      // Use the API function to update the status
      await updateCheckInStatus(
        ticket_id,
        user_id,
        selectedStatusForUpdate,
        normalizedSubStatus,
        normalizedMessage
      );

      setDialogMessage(`Status updated successfully to ${statusLabel(selectedStatusForUpdate)}`);
      setDialogType("success");
      setOpenDialog(true);

      setTicketData((prev) =>
        prev
          ? {
              ...prev,
              checkin_status: selectedStatusForUpdate,
              checkin_sub_status: normalizedSubStatus,
              checkin_message: normalizedMessage,
            }
          : prev
      );

      // Reset dialog state
      setSelectedStatusForUpdate(null);
      setCheckinSubStatusValue("");
      setCheckinMessageValue("");
      setSelectedMissingInfoMessages([]);

      // Hide loading immediately after API call completes
      setUploadLoading(false);

      // Refresh ticket data in the background without blocking UI
      setTimeout(async () => {
        try {
          console.log("Refreshing ticket data after status update in background...");
          const refreshedData = await fetchTicketData(ticketData.ticket_id, ticketData.user_id || user_id);
          setTicketData(refreshedData);
        } catch (refreshError) {
          console.error("Error refreshing ticket data:", refreshError);
        }
      }, 0);
    } catch (error) {
      console.error("Error updating status:", error);
      setDialogMessage(error.message || "Error updating status. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
      setUploadLoading(false);
    }
  };

  const isMissingInfoSelected = checkinSubStatusValue === "MISSING_INFO";

  // Function to handle passenger form input changes
  const handlePassengerInputChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setPassengerFormData({
        ...passengerFormData,
        [parent]: {
          ...passengerFormData[parent],
          [child]: value,
        },
      });
    } else {
      setPassengerFormData({
        ...passengerFormData,
        [name]: value,
      });
    }
  };

  // Function to start editing passenger details (only seat, meal, and baggage)
  const startEditingPassenger = (passenger) => {
    setEditingPassenger(passenger.passengerFlightId);
    setPassengerFormData({
      first_name: passenger.first_name || "",
      last_name: passenger.last_name || "",
      seat: getSeatNumber(passenger) || "",
      meal_preference: getMealPreference(passenger) || "",
      baggage_allowance: {
        checkin: getBaggageAllowance(passenger).checkin || "",
        cabin: getBaggageAllowance(passenger).cabin || "",
      },
    });
  };

  // Function to cancel passenger editing
  const cancelEditingPassenger = () => {
    setEditingPassenger(null);
    setPassengerFormData({
      first_name: "",
      last_name: "",
      seat: "",
      meal_preference: "",
      baggage_allowance: {
        checkin: "",
        cabin: "",
      },
    });
  };

  // Function to update passenger details
  const updatePassengerDetails = async () => {
    try {
      setUploadLoading(true);

      const passengerToUpdate = ticketData.pax_data.find(
        (passenger) => passenger.passengerFlightId === editingPassenger
      );

      if (!passengerToUpdate) {
        throw new Error("Passenger not found");
      }

      const response = await fetch(
        `${ADMIN_API_BASE_URL}/update`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
          },
          body: JSON.stringify({
            type: "PASSENGER",
            operationType: "UPDATE",
            body: {
              passengerFlightId: editingPassenger,
              // Only allow editing of seat, meal, and baggage - NOT firstName/lastName
              seat: passengerFormData.seat,
              meal: passengerFormData.meal_preference,
              checkinBaggage: passengerFormData.baggage_allowance.checkin,
              cabinBaggage: passengerFormData.baggage_allowance.cabin,
              sequenceNumber: passengerToUpdate.sequence_number || "",
            },
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Update the ticket data with the updated passenger (only seat, meal, baggage)
        const updatedPassengers = ticketData.pax_data.map((passenger) => {
          if (passenger.passengerFlightId === editingPassenger) {
            return {
              ...passenger,
              // Only update seat, meal, and baggage - NOT firstName/lastName
              seat_number: passengerFormData.seat,
              meal_preference: passengerFormData.meal_preference,
              baggage_allowance: {
                checkin: passengerFormData.baggage_allowance.checkin,
                cabin: passengerFormData.baggage_allowance.cabin,
              },
            };
          }
          return passenger;
        });

        setTicketData({
          ...ticketData,
          pax_data: updatedPassengers,
        });

        setDialogMessage("Passenger details updated successfully");
        setDialogType("success");
        cancelEditingPassenger();
        const refreshData = await fetchTicketData(ticket_id, user_id);
        setTicketData(refreshData);
      } else {
        setDialogMessage(data.message || "Error updating passenger details");
        setDialogType("error");
      }

      setOpenDialog(true);
    } catch (error) {
      console.error("Error updating passenger details:", error);
      setDialogMessage("Error updating passenger details. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
    }
  };

  // Function to start editing user details
  const startEditingUserDetails = () => {
    if (ticketData?.userData && ticketData.userData.length > 0) {
      const userData = ticketData.userData[0];
      // Extract country code and phone number if mobileNumber exists
      let countryCode = "";
      let phoneNumber = "";

      if (userData.mobileNumber) {
        // Check if mobileNumber is an object
        if (typeof userData.mobileNumber === 'object') {
          // If it's an object, try to extract countryCode and phoneNumber directly
          countryCode = userData.mobileNumber.countryCode || "";
          phoneNumber = userData.mobileNumber.mobileNumber || userData.mobileNumber.phoneNumber || "";
        } else {
          // If it's a string or number, parse it
          const mobileNumberStr = userData.mobileNumber.toString();
          // Check if it starts with a + and extract country code
          if (mobileNumberStr.startsWith('+')) {
            // Find the first non-digit character after the +
            const countryCodeEndIndex = mobileNumberStr.search(/\d+/);
            if (countryCodeEndIndex > 0) {
              countryCode = mobileNumberStr.substring(0, countryCodeEndIndex);
              phoneNumber = mobileNumberStr.substring(countryCodeEndIndex);
            } else {
              // If no clear separation, make a best guess (first 2-3 digits)
              countryCode = mobileNumberStr.substring(0, 3);
              phoneNumber = mobileNumberStr.substring(3);
            }
          } else {
            // If no + prefix, assume no country code is present
            phoneNumber = mobileNumberStr;
          }
        }
      }

      setUserFormData({
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        gender: userData.gender || "",
        dob: userData.dob || "",
        passport: userData.userDocument?.passport || userData.idNumber || "",
        nationality:
          userData.userDocument?.nationality || userData.nationality || "",
        passport_expiry: userData.userDocument?.passport_expiry || "",
        countryCode: countryCode,
        phoneNumber: phoneNumber,
      });
      setEditingUserDetails(true);
    }
  };

  // Function to cancel user details editing
  const cancelEditingUserDetails = () => {
    setEditingUserDetails(false);
  };

  // Function to handle user form input changes
  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    setUserFormData({
      ...userFormData,
      [name]: value,
    });
  };

  // Function to update user details
  const updateUserDetails = async () => {
    try {
      setUploadLoading(true);

      const userDataToUpdate = ticketData.userData[0];

      if (!userDataToUpdate) {
        throw new Error("User data not found");
      }

      const response = await fetch(
        `${ADMIN_API_BASE_URL}/update`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
          },
          body: JSON.stringify({
            type: "USER",
            operationType: "UPDATE",
            body: {
              userId: userDataToUpdate.userId,
              firstName: userFormData.firstName,
              lastName: userFormData.lastName,
              gender: userFormData.gender,
              dob: userFormData.dob,
              passport: userFormData.passport,
              nationality: userFormData.nationality,
              passport_expiry: userFormData.passport_expiry,
              mobileNumber: userFormData.countryCode || userFormData.phoneNumber
                ? `${userFormData.countryCode || ""}${userFormData.phoneNumber || ""}`
                : "",
            },
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Update the ticket data with the updated user
        // const updatedUserData = ticketData.userData.map((user) => {
        //   if (user.userId === userDataToUpdate.userId) {
        //     return {
        //       ...user,
        //       firstName: userFormData.firstName,
        //       lastName: userFormData.lastName,
        //       gender: userFormData.gender,
        //       dob: userFormData.dob,
        //       mobileNumber: userFormData.countryCode || userFormData.phoneNumber
        //         ? `${userFormData.countryCode || ""}${userFormData.phoneNumber || ""}`
        //         : "",
        //       userDocument: {
        //         passport: userFormData.passport,
        //         nationality: userFormData.nationality,
        //         passport_expiry: userFormData.passport_expiry,
        //       },
        //     };
        //   }
        //   return user;
        // });

        const refreshData = await fetchTicketData(ticket_id, user_id);
      setTicketData(refreshData);

        setDialogMessage("User details updated successfully");
        setDialogType("success");
        cancelEditingUserDetails();
      } else {
        setDialogMessage(data.message || "Error updating user details");
        setDialogType("error");
      }

      setOpenDialog(true);
    } catch (error) {
      console.error("Error updating user details:", error);
      setDialogMessage("Error updating user details. Please try again.");
      setDialogType("error");
      setOpenDialog(true);
    } finally {
      setUploadLoading(false);
    }
  };

  const handleAddPassenger = () => {
    if (ticketData?.flight_data?.length > 0) {
      // Always use the first flight ID
      setSelectedFlightId(ticketData.flight_data[0].id);
      setShowAddPassengerForm(true);
    } else {
      showToastMessage("No flights available to add passenger", "error");
    }
  };

  const handleFlightSelect = (flightId) => {
    console.log("handleFlightSelect called with flightId:", flightId);
    setSelectedFlightId(flightId);
    setShowFlightSelection(false);

    // This function is now only used for adding passengers
    // since ticket document uploads always use the first flight ID
    if (flightSelectionAction === 'addPassenger') {
      console.log("Flight selection for adding passenger");
      setShowAddPassengerForm(true);
    }

    // Reset the action after handling
    setFlightSelectionAction(null);
  };

  const handleAddPassengerFormChange = (e) => {
    const { name, value } = e.target;
    setAddPassengerFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddPassengerSubmit = async () => {
    try {
      if (!addPassengerFormData.firstName) {
        showToastMessage("First name is required", "error");
        return;
      }

      if (!addPassengerFormData.lastName) {
        showToastMessage("Last name is required", "error");
        return;
      }

      setUploadLoading(true);

      const data = {
        flightId: selectedFlightId,
        userId: ticketData.user_id,
        ticketId: ticket_id,
        firstName: addPassengerFormData.firstName,
        lastName: addPassengerFormData.lastName,
        seat: addPassengerFormData.seat,
        meal: addPassengerFormData.meal,
        checkinBaggage: addPassengerFormData.checkinBaggage,
        cabinBaggage: addPassengerFormData.cabinBaggage,
        sequenceNumber: addPassengerFormData.sequenceNumber,
      };

      await addPassenger(data);

      // Refresh the ticket data
      const refreshData = await fetchTicketData(ticket_id, user_id);

      showToastMessage("Passenger added successfully", "success");
      setShowAddPassengerForm(false);
      setAddPassengerFormData({
        firstName: "",
        lastName: "",
        seat: "",
        meal: "",
        checkinBaggage: "",
        cabinBaggage: "",
        sequenceNumber: "",
      });
      setTicketData(refreshData);
    } catch (error) {
      console.error("Error adding passenger:", error);
      showToastMessage(error.message || "Failed to add passenger", "error");
    } finally {
      setUploadLoading(false);
    }
  };

  const handleAddPassengerFormClose = () => {
    setShowAddPassengerForm(false);
    setAddPassengerFormData({
      firstName: "",
      lastName: "",
      seat: "",
      meal: "",
      checkinBaggage: "",
      cabinBaggage: "",
      sequenceNumber: "",
    });
  };

  return (
    <MainLayout activeTab={sourceTab || 'webCheckIn'}>


      {/* Main Content Area */}
      {loading ? (
        <div className="flex justify-center items-center flex-1 w-full">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : error ? (
        <div className="w-full p-4">
          <div className="bg-red-100 text-red-700 p-4 rounded-md">
            <p>{error}</p>
          </div>
        </div>
      ) : (
        <div className="flex flex-1 min-h-0 overflow-hidden">
          {/* Main content area with tabs */}
          <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
            {/* Tabs - Sticky */}
            <div className="tabs-list px-6 pt-4">
                <button
                  className={`tab ${activeTab === "flightDetails" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("flightDetails")}
                >
                  <div className="tab-label">
                    <div>Flight</div>
                    <div>Details</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "ticketInfo" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("ticketInfo")}
                >
                  <div className="tab-label">
                    <div>Ticket</div>
                    <div>Information</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "boardingPasses" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("boardingPasses")}
                >
                  <div className="tab-label">
                    <div>Boarding</div>
                    <div>Passes</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "ticketDocuments" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("ticketDocuments")}
                >
                  <div className="tab-label">
                    <div>Ticket</div>
                    <div>Documents</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "checkinSteps" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("checkinSteps")}
                >
                  <div className="tab-label">
                    <div>Check-in</div>
                    <div>Steps</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "userDetails" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("userDetails")}
                >
                  <div className="tab-label">
                    <div>User</div>
                    <div>Details</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "passengers" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("passengers")}
                >
                  <div className="tab-label">
                    <div>Passengers</div>
                  </div>
                </button>
                <button
                  className={`tab ${activeTab === "userPreferences" ? "tab-active" : ""}`}
                  onClick={() => handleTabClick("userPreferences")}
                >
                  <div className="tab-label">
                    <div>User</div>
                    <div>Preferences</div>
                  </div>
                </button>
            </div>

            {/* Tab Content */}
            <div className="tab-content-container px-6 pb-6 overflow-y-auto">
              {/* Flight Details Tab */}
              <div
                id="flightDetails"
                className={`tab-content ${
                  activeTab === "flightDetails" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-6">
                  <div className="flex items-center mb-6">
                    <h2 className="text-xl font-bold">Flight Information</h2>
                    {ticketData?.is_cancelled && (
                      <span className="ml-3 px-2 py-1 bg-red-100 text-red-600 text-xs font-medium rounded-full">
                        CANCELLED
                      </span>
                    )}
                  </div>

                  {ticketData?.flight_data &&
                  ticketData.flight_data.length > 0 ? (
                    <div className="space-y-6">
                      {ticketData.flight_data.map((flight, index) => (
                        <div
                          key={index}
                          className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm"
                        >
                          <div className="flex justify-between items-start mb-6">
                            <div>
                              <h3 className="text-lg font-bold mb-1">
                                Flight {flight.flight_number || "SV1234"}
                              </h3>
                              <p className="text-gray-500">
                                {flight.airline_name || "Unknown Airlines"}
                              </p>

                              {/* Check if it's an international flight based on different countries */}
                              {flight.departure_data?.country &&
                                flight.arrival_data?.country &&
                                flight.departure_data.country !==
                                  flight.arrival_data.country && (
                                  <span className="badge badge-info mt-1 inline-flex">
                                    International Flight
                                  </span>
                                )}
                            </div>
                            <div className="flex items-center">
                              {flight.airline_logo && (
                                <img
                                  src={flight.airline_logo}
                                  alt={flight.airline_name || "Airline"}
                                  className="h-8 mr-3"
                                />
                              )}
                            </div>
                          </div>

                          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                            <div className="flex items-center mb-4 md:mb-0">
                              <div className="text-center">
                                <p className="text-xl font-bold">
                                  {flight.departure_data?.airport_iata ||
                                    flight.origin ||
                                    "RUH"}
                                </p>
                                <p className="text-sm text-gray-500">
                                  {flight.departure_data?.country ||
                                    flight.origin_country ||
                                    "Unknown Country"}
                                </p>
                                {flight.departure_data?.terminal && (
                                  <p className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded mt-1">
                                    Terminal {flight.departure_data.terminal}
                                  </p>
                                )}
                              </div>

                              <div className="flex-1 mx-8 relative">
                                <div className="h-0.5 bg-gray-300 w-full absolute top-1/2"></div>
                                <div className="flex justify-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-blue-500 bg-white relative"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M10.894 2.553a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
                                  </svg>
                                </div>
                              </div>

                              <div className="text-center">
                                <p className="text-xl font-bold">
                                  {flight.arrival_data?.airport_iata ||
                                    flight.destination ||
                                    "JED"}
                                </p>
                                <p className="text-sm text-gray-500">
                                  {flight.arrival_data?.country ||
                                    flight.destination_country ||
                                    "Unknown Country"}
                                </p>
                                {flight.arrival_data?.terminal && (
                                  <p className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded mt-1">
                                    Terminal {flight.arrival_data.terminal}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="border-t md:border-t-0 md:border-l border-gray-200 pt-4 md:pt-0 md:pl-8 md:ml-8">
                              <div className="grid grid-cols-2 gap-6">
                                <div className="overflow-hidden">
                                  <p className="text-sm text-gray-500 mb-1">
                                    Departure
                                  </p>
                                  <p className="font-medium truncate">
                                    {flight.departure_data?.planned_date
                                      ? dayjs
                                          .utc(
                                            flight.departure_data.planned_date
                                          )
                                          .format("D/M/YYYY")
                                      : dayjs
                                          .utc(
                                            flight.departure_date ||
                                              "2025-04-04T17:30:00.000Z"
                                          )
                                          .format("D/M/YYYY")}
                                  </p>
                                  <p className="text-sm truncate">
                                    {flight.departure_data?.planned_date
                                      ? dayjs
                                          .utc(
                                            flight.departure_data.planned_date
                                          )
                                          .format("hh:mm A")
                                      : dayjs
                                          .utc(
                                            flight.departure_date ||
                                              "2025-04-04T17:30:00.000Z"
                                          )
                                          .format("hh:mm A")}
                                  </p>
                                </div>

                                <div className="overflow-hidden">
                                  <p className="text-sm text-gray-500 mb-1">
                                    Arrival
                                  </p>
                                  <p className="font-medium truncate">
                                    {flight.arrival_data?.planned_date
                                      ? dayjs
                                          .utc(flight.arrival_data.planned_date)
                                          .format("D/M/YYYY")
                                      : dayjs
                                          .utc(
                                            flight.arrival_date ||
                                              "2025-04-04T17:30:00.000Z"
                                          )
                                          .format("D/M/YYYY")}
                                  </p>
                                  <p className="text-sm truncate">
                                    {flight.arrival_data?.planned_date
                                      ? dayjs
                                          .utc(flight.arrival_data.planned_date)
                                          .format("hh:mm A")
                                      : dayjs
                                          .utc(
                                            flight.arrival_date ||
                                              "2025-04-04T17:30:00.000Z"
                                          )
                                          .format("hh:mm A")}
                                  </p>
                                </div>
                              </div>
                              {flight.boarding_gate && (
                                <div className="mt-4">
                                  <p className="text-sm text-gray-500 mb-1">
                                    Boarding Gate
                                  </p>
                                  <p className="font-medium">
                                    {flight.boarding_gate}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-500">
                      No flight information available
                    </p>
                  )}
                </div>
              </div>

              {/* Ticket Information Tab */}
              <div
                id="ticketInfo"
                className={`tab-content ${
                  activeTab === "ticketInfo" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-6">
                  <div className="flex justify-between items-center mb-6">
                    <div className="flex items-center">
                      <h2 className="text-xl font-bold">Ticket Information</h2>
                      {ticketData?.is_cancelled && (
                        <span className="ml-3 px-2 py-1 bg-red-100 text-red-600 text-xs font-medium rounded-full">
                          CANCELLED
                        </span>
                      )}
                    </div>
                    <div className="flex space-x-2">
                      <button
                        className="btn btn-sm bg-yellow-50 text-yellow-600 border border-yellow-200 hover:bg-yellow-100 hover:border-yellow-300 rounded px-3 py-1 flex items-center gap-1"
                        onClick={() => setShowCancelTicketConfirmation(true)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                        </svg>
                        Cancel Ticket
                      </button>
                      <button
                        className="btn btn-sm bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 hover:border-red-300 rounded px-3 py-1 flex items-center gap-1"
                        onClick={() => setShowDeleteTicketConfirmation(true)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Delete Ticket
                      </button>
                    </div>
                  </div>

                  {/* Ticket Source and Email Text Data */}
                  <div className="mb-6 border-b border-gray-200 pb-6">
                    <div className="grid grid-cols-1 gap-6">
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <h3 className="text-md font-semibold">Ticket Source</h3>
                          {ticketData?.ticket_source?.toLowerCase() === "email" && (
                            <button
                              onClick={handleFetchParsedEmailText}
                              disabled={parsedEmailTextLoading}
                              className="text-blue-600 hover:text-blue-800 text-sm flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              <EnvelopeClosedIcon className="h-4 w-4 mr-1" />
                              {parsedEmailTextLoading ? 'Fetching...' : 'Fetch Email Text'}
                            </button>
                          )}
                        </div>
                        <div className="inline-flex">
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getTicketSourceTailwindClasses(ticketData?.ticket_source)}`}>
                            {normalizeTicketSource(ticketData?.ticket_source)}
                          </span>
                        </div>
                      </div>

                      {emailTextLoading ? (
                        <div className="space-y-2">
                          <h3 className="text-md font-semibold">Loading Email Data...</h3>
                          <div className="bg-gray-50 p-4 rounded-md text-sm text-gray-700">
                            <div className="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent text-blue-600 rounded-full mr-2"></div>
                            Fetching email text data...
                          </div>
                        </div>
                      ) : emailTextData ? (
                        <>
                          {emailTextData.syncDate && (
                            <div className="space-y-2">
                              <h3 className="text-md font-semibold">Sync Date</h3>
                              <p className="text-sm text-gray-700">
                                {ticketData?.ticketSavedAt || "Not available"}
                              </p>
                            </div>
                          )}

                          {/* Parsed Text Accordion - Closed by default */}
                          <Accordion type="single" collapsible className="w-full">
                            <AccordionItem value="parsed-text" className="border rounded-lg">
                              <AccordionTrigger className="px-4 py-3 text-base font-semibold hover:no-underline">
                                <div className="flex justify-between items-center w-full pr-4">
                                  <span>Parsed Text</span>
                                  {emailTextData?.parsedText && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        copyToClipboard(
                                          typeof emailTextData.parsedText === 'object'
                                            ? JSON.stringify(emailTextData.parsedText, null, 2)
                                            : emailTextData.parsedText
                                        );
                                      }}
                                      className="text-blue-600 hover:text-blue-800 text-sm flex items-center mr-4"
                                    >
                                      <ClipboardCopyIcon className="h-4 w-4 mr-1" />
                                      Copy Full Text
                                    </button>
                                  )}
                                </div>
                              </AccordionTrigger>
                              <AccordionContent className="px-4 pb-4">
                                {emailTextData?.parsedText ? (
                                  typeof emailTextData.parsedText === 'object' ? (
                                    <div className="space-y-3">
                                      {/* Display parsed_text as an object with fields - dynamic approach */}
                                      <div className="bg-gray-50 p-4 rounded-md text-sm text-gray-700 overflow-y-auto max-h-96">
                                        <div className="grid grid-cols-1 gap-3">
                                          {Object.entries(emailTextData.parsedText).map(([key, value]) => {
                                            // Format the key for display
                                            const formattedKey = key
                                              .replace(/([A-Z])/g, ' $1') // Add space before capital letters
                                              .replace(/_/g, ' ') // Replace underscores with spaces
                                              .replace(/4omini/g, 'for Omini') // Replace 4omini with for Omini
                                              .split(' ')
                                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                              .join(' ');

                                            // Handle different value types
                                            if (typeof value === 'string') {
                                              return (
                                                <div key={key}>
                                                  <h4 className="font-medium mb-1">{formattedKey}:</h4>
                                                  <div className="bg-white p-2 rounded border border-gray-200 max-h-40 overflow-y-auto">
                                                    {value.length > 300 ? value.substring(0, 300) + "..." : value}
                                                  </div>
                                                </div>
                                              );
                                            } else if (typeof value === 'boolean') {
                                              return (
                                                <div key={key}>
                                                  <h4 className="font-medium mb-1">{formattedKey}:</h4>
                                                  <div className={`bg-white p-2 rounded border ${
                                                    value ? "border-green-200 text-green-700" : "border-red-200 text-red-700"
                                                  }`}>
                                                    {value ? "Yes" : "No"}
                                                  </div>
                                                </div>
                                              );
                                            } else if (value === null || value === undefined) {
                                              return (
                                                <div key={key}>
                                                  <h4 className="font-medium mb-1">{formattedKey}:</h4>
                                                  <div className="bg-white p-2 rounded border border-gray-200 text-gray-500">
                                                    Not available
                                                  </div>
                                                </div>
                                              );
                                            } else if (typeof value === 'object') {
                                              return (
                                                <div key={key}>
                                                  <h4 className="font-medium mb-1">{formattedKey}:</h4>
                                                  <div className="bg-white p-2 rounded border border-gray-200 max-h-40 overflow-y-auto">
                                                    <pre className="text-xs">{JSON.stringify(value, null, 2)}</pre>
                                                  </div>
                                                </div>
                                              );
                                            } else {
                                              // For numbers and other primitive types
                                              return (
                                                <div key={key}>
                                                  <h4 className="font-medium mb-1">{formattedKey}:</h4>
                                                  <div className="bg-white p-2 rounded border border-gray-200">
                                                    {String(value)}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    // Handle legacy string format
                                    <div className="bg-gray-50 p-4 rounded-md text-sm text-gray-700 max-h-96 overflow-y-auto">
                                      {emailTextData.parsedText.length > 300
                                        ? emailTextData.parsedText.substring(0, 300) + "..."
                                        : emailTextData.parsedText}
                                    </div>
                                  )
                                ) : (
                                  <div className="bg-gray-50 p-4 rounded-md text-sm text-gray-700">
                                    Not available
                                  </div>
                                )}
                              </AccordionContent>
                            </AccordionItem>
                          </Accordion>
                        </>
                      ) : (
                        <div className="space-y-2">
                          <h3 className="text-md font-semibold">Email Data</h3>
                          <div className="bg-gray-50 p-4 rounded-md text-sm text-gray-700">
                            Email text data not available
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Add Passenger Button */}
                  <div className="flex justify-end mb-4">
                    <button
                      className="btn btn-primary"
                      onClick={handleAddPassenger}
                      disabled={uploadLoading}
                    >
                      Add Passenger
                    </button>
                  </div>

                  {/* Loader for passenger actions */}
                  {uploadLoading && (
                    <div className="flex justify-center items-center mb-4">
                      <svg className="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span className="ml-2 text-blue-600">Processing...</span>
                    </div>
                  )}

                  {/* Add Passenger Form */}
                  {showAddPassengerForm && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                      <div className="bg-white rounded-lg p-6 max-w-md w-full">
                        <h3 className="text-xl font-bold mb-4">
                          Add Passenger
                        </h3>
                        <form
                          className="space-y-4"
                          onSubmit={(e) => {
                            e.preventDefault();
                            handleAddPassengerSubmit();
                          }}
                        >
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              First Name *
                            </label>
                            <input
                              type="text"
                              name="firstName"
                              value={addPassengerFormData.firstName}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                              required
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Last Name
                            </label>
                            <input
                              type="text"
                              name="lastName"
                              value={addPassengerFormData.lastName}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Seat Number
                            </label>
                            <input
                              type="text"
                              name="seat"
                              value={addPassengerFormData.seat}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Meal Preference
                            </label>
                            <input
                              type="text"
                              name="meal"
                              value={addPassengerFormData.meal}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Check-in Baggage
                            </label>
                            <input
                              type="text"
                              name="checkinBaggage"
                              value={addPassengerFormData.checkinBaggage}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                              placeholder="e.g., 25kg"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Cabin Baggage
                            </label>
                            <input
                              type="text"
                              name="cabinBaggage"
                              value={addPassengerFormData.cabinBaggage}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                              placeholder="e.g., 8kg"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Sequence Number
                            </label>
                            <input
                              type="text"
                              name="sequenceNumber"
                              value={addPassengerFormData.sequenceNumber}
                              onChange={handleAddPassengerFormChange}
                              className="border border-gray-300 rounded p-2 w-full"
                            />
                          </div>
                          <div className="flex justify-end space-x-2">
                            <button
                              type="button"
                              className="btn btn-outline"
                              onClick={handleAddPassengerFormClose}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={uploadLoading}
                            >
                              {uploadLoading ? "..." : "Add Passenger"}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}

                  <p className="text-gray-500 mb-4">
                    {ticketData?.pax_data?.length || 0} passenger(s)
                  </p>

                  {ticketData?.pax_data && ticketData.pax_data.length > 0 ? (
                    <div>
                      {ticketData.flight_data.map((flight) => (
                        <React.Fragment key={flight.id}>
                          <div className="mb-8">
                            <div className="flex items-center mb-4 bg-gray-50 p-3 rounded-lg">
                              <h3 className="text-lg font-semibold mr-4">
                                Flight {flight.flight_number}
                              </h3>
                              <div className="text-sm text-gray-500">
                                {flight.departure_data.airport_iata} → {flight.arrival_data.airport_iata}
                              </div>
                            </div>
                            <div className="overflow-x-auto">
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                  <tr>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      First Name
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Last Name
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Type
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Seat
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Meal
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Baggage
                                    </th>
                                    <th
                                      scope="col"
                                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {ticketData.pax_data
                                    .filter((p) => p.flight_id === flight.id)
                                    .map((passenger, index) => (
                                      <tr key={index}>
                                        {editingPassenger ===
                                        passenger.passengerFlightId ? (
                                          // Editing mode
                                          <>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm font-medium text-gray-900 bg-gray-50 p-2 rounded border">
                                                {passengerFormData.first_name || ""}
                                                <div className="text-xs text-gray-500 mt-1">Read-only</div>
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm font-medium text-gray-900 bg-gray-50 p-2 rounded border">
                                                {passengerFormData.last_name || ""}
                                                <div className="text-xs text-gray-500 mt-1">Read-only</div>
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm text-gray-900">
                                                {passenger.pax_type ||
                                                  passenger.type ||
                                                  ""}
                                              </div>
                                              <div className="text-xs text-gray-500">
                                                {passenger.gender || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <input
                                                type="text"
                                                name="seat"
                                                value={passengerFormData.seat}
                                                onChange={handlePassengerInputChange}
                                                className="border border-gray-300 rounded p-1 w-full"
                                              />
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <input
                                                type="text"
                                                name="meal_preference"
                                                value={passengerFormData.meal_preference}
                                                onChange={handlePassengerInputChange}
                                                className="border border-gray-300 rounded p-1 w-full"
                                              />
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="space-y-2">
                                                <div className="flex items-center">
                                                  <span className="text-xs mr-1">
                                                    Check-in:
                                                  </span>
                                                  <input
                                                    type="text"
                                                    name="baggage_allowance.checkin"
                                                    value={
                                                      passengerFormData.baggage_allowance
                                                        .checkin
                                                    }
                                                    onChange={handlePassengerInputChange}
                                                    className="border border-gray-300 rounded p-1 w-full"
                                                  />
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="text-xs mr-1">
                                                    Cabin:
                                                  </span>
                                                  <input
                                                    type="text"
                                                    name="baggage_allowance.cabin"
                                                    value={
                                                      passengerFormData.baggage_allowance
                                                        .cabin
                                                    }
                                                    onChange={handlePassengerInputChange}
                                                    className="border border-gray-300 rounded p-1 w-full"
                                                  />
                                                </div>
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="flex space-x-2">
                                                <button
                                                  className="btn btn-sm bg-green-50 text-green-600 border border-green-200 hover:bg-green-100 hover:border-green-300 rounded px-3 py-1"
                                                  onClick={updatePassengerDetails}
                                                  disabled={uploadLoading}
                                                >
                                                  {uploadLoading ? "..." : "Save"}
                                                </button>
                                                <button
                                                  className="btn btn-sm bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 rounded px-3 py-1"
                                                  onClick={cancelEditingPassenger}
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            </td>
                                          </>
                                        ) : (
                                          // View mode
                                          <>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm font-medium text-gray-900">
                                                {passenger.first_name || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm font-medium text-gray-900">
                                                {passenger.last_name || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm text-gray-900">
                                                {passenger.pax_type ||
                                                  passenger.type ||
                                                  ""}
                                              </div>
                                              <div className="text-xs text-gray-500">
                                                {passenger.gender || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm text-gray-900">
                                                {getSeatNumber(passenger) || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="text-sm text-gray-900">
                                                {getMealPreference(passenger) || ""}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="space-y-1">
                                                {getBaggageAllowance(passenger)
                                                  .checkin && (
                                                  <div className="text-sm text-gray-900">
                                                    <span className="font-medium">
                                                      Check-in:
                                                    </span>{" "}
                                                    {
                                                      getBaggageAllowance(passenger)
                                                        .checkin
                                                    }
                                                  </div>
                                                )}
                                                {getBaggageAllowance(passenger).cabin && (
                                                  <div className="text-sm text-gray-900">
                                                    <span className="font-medium">
                                                      Cabin:
                                                    </span>{" "}
                                                    {getBaggageAllowance(passenger).cabin}
                                                  </div>
                                                )}
                                                {!getBaggageAllowance(passenger)
                                                  .checkin &&
                                                  !getBaggageAllowance(passenger)
                                                    .cabin && (
                                                    <div className="text-sm text-gray-500">
                                                      No baggage info
                                                    </div>
                                                  )}
                                              </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                              <div className="flex space-x-2">
                                                <button
                                                  className="btn btn-sm bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 rounded px-3 py-1"
                                                  onClick={() => startEditingPassenger(passenger)}
                                                  disabled={uploadLoading}
                                                >
                                                  Edit
                                                </button>
                                                <button
                                                  className="btn btn-sm bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 hover:border-red-300 rounded px-3 py-1"
                                                  onClick={() => {
                                                    setPassengerToDelete(
                                                      passenger.passengerFlightId
                                                    );
                                                    setShowDeleteConfirmation(true);
                                                  }}
                                                  disabled={uploadLoading}
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            </td>
                                          </>
                                        )}
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-500">
                      No passenger information available
                    </p>
                  )}
                </div>
              </div>

              {/* Boarding Passes Tab */}
              <div
                id="boardingPasses"
                className={`tab-content ${
                  activeTab === "boardingPasses" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-6">
                  <h2 className="text-xl font-bold mb-6">Boarding Passes</h2>

                  {ticketData?.pax_data && ticketData.pax_data.length > 0 ? (
                    <>
                      {ticketData.flight_data.map((flight) => (
                        <React.Fragment key={flight.id}>
                          <div className="mb-8">
                            <div className="flex items-center mb-4">
                              <h3 className="text-lg font-semibold mr-4">
                                Flight {flight.flight_number}
                              </h3>
                              <div className="text-sm text-gray-500">
                                {flight.departure_data.airport_iata} → {flight.arrival_data.airport_iata}
                              </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                              {ticketData.pax_data
                                .filter((p) => p.flight_id === flight.id)
                                .map((passenger, index) => (
                                  <div
                                    key={index}
                                    className="border border-gray-200 rounded-lg p-6 shadow-sm"
                                  >
                                    <div className="flex justify-between items-start mb-4">
                                      <div>
                                        <h3 className="font-semibold text-lg mb-1">
                                          {passenger.first_name} {passenger.last_name}
                                        </h3>
                                        <p className="text-gray-500 text-sm">
                                          {passenger.pax_type ||
                                            passenger.type ||
                                            "Adult"}
                                        </p>
                                        {getSeatNumber(passenger) && (
                                          <p className="text-gray-500 text-sm">
                                            Seat: {getSeatNumber(passenger)}
                                          </p>
                                        )}
                                      </div>
                                      <span
                                        className={`badge badge-${
                                          hasBoardingPass(passenger)
                                            ? "success"
                                            : "warning"
                                        }`}
                                      >
                                        {hasBoardingPass(passenger)
                                          ? "Available"
                                          : "Not Available"}
                                      </span>
                                    </div>

                                    <div className="space-y-4 mt-6">
                                      {hasBoardingPass(passenger) ? (
                                        <>
                                          {/* QR Code preview */}
                                          <div className="flex justify-center mb-4">
                                            <div className="border border-gray-200 rounded-md p-4 bg-white inline-block">
                                              <img
                                                src={getBoardingPassUrl(
                                                  passenger
                                                )}
                                                alt="Boarding Pass QR"
                                                className="h-32 w-32 object-contain"
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src =
                                                    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgZmlsbD0iI2YzZjRmNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0ic2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNnB4IiBmaWxsPSIjOWNhM2FmIj5QcmV2aWV3IG5vdCBhdmFpbGFibGU8L3RleHQ+PC9zdmc+";
                                                  }}
                                              />
                                            </div>
                                          </div>
                                          <div className="flex flex-col space-y-2">
                                            <button
                                              className={`btn btn-outline w-full flex items-center justify-center ${
                                                hasBoardingPass(passenger) && !downloadLoading
                                                  ? "btn-success text-green-600 border-green-300 hover:bg-green-50"
                                                  : "text-gray-400 border-gray-300 cursor-not-allowed opacity-50"
                                              }`}
                                              onClick={() => handleBoardingPassDownload(passenger)}
                                              disabled={!hasBoardingPass(passenger) || downloadLoading}
                                              title={
                                                downloadLoading
                                                  ? "Downloading..."
                                                  : hasBoardingPass(passenger)
                                                  ? "Download boarding pass"
                                                  : "Boarding pass not available"
                                              }
                                            >
                                              {downloadLoading ? (
                                                <svg
                                                  className="animate-spin w-4 h-4 mr-2"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                >
                                                  <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                  />
                                                  <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                  />
                                                </svg>
                                              ) : (
                                                <svg
                                                  className="w-4 h-4 mr-2"
                                                  fill="none"
                                                  stroke="currentColor"
                                                  viewBox="0 0 24 24"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                  />
                                                </svg>
                                              )}
                                              {downloadLoading ? "Downloading..." : "Download Boarding Pass"}
                                            </button>
                                            <button
                                              className="btn btn-outline btn-danger w-full flex items-center justify-center text-red-600 border-red-300 hover:bg-red-50"
                                              onClick={() => {
                                                fetch(`${ADMIN_API_BASE_URL}/update`, {
                                                  method: 'PATCH',
                                                  headers: {
                                                    'Content-Type': 'application/json',
                                                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzNTc0OTgxfQ._idqKSQIX6-PufOyQg9TTclXJndfJS_RZhKUPyLMgFc'
                                                  },
                                                  body: JSON.stringify({
                                                    "type": "BOARDING_PASS",
                                                    "operationType": "DELETE",
                                                    "body": {
                                                      "passengerFlightId": passenger.passengerFlightId
                                                    }
                                                  })
                                                })
                                                .then(response => response.json())
                                                .then(data => {
                                                  if (data.success) {
                                                    showToastMessage("Boarding pass deleted successfully", "success");
                                                    // Refresh the page to show updated data
                                                    window.location.reload();
                                                  } else {
                                                    showToastMessage(data.message || "Failed to delete boarding pass", "error");
                                                  }
                                                })
                                                .catch(error => {
                                                  console.error("Error deleting boarding pass:", error);
                                                  showToastMessage("Error deleting boarding pass", "error");
                                                });
                                              }}
                                            >
                                              Delete Boarding Pass
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="space-y-2">
                                          <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Upload Boarding Pass
                                          </label>
                                          <div className="relative">
                                            <input
                                              type="file"
                                              id={`boarding-pass-${passenger.user_id}`}
                                              className="hidden"
                                              onChange={(e) =>
                                                handleFileChange(
                                                  e,
                                                  passenger.user_id,
                                                  "boarding_pass"
                                                )
                                              }
                                              accept=".pdf,.png,.jpg,.jpeg"
                                            />
                                            <label
                                              htmlFor={`boarding-pass-${passenger.user_id}`}
                                              className="btn btn-outline w-full flex items-center justify-center cursor-pointer"
                                            >
                                              Choose File
                                            </label>
                                          </div>
                                          <button
                                            className="btn btn-primary w-full mt-2 flex items-center justify-center"
                                            onClick={() =>
                                              handleUpload(
                                                passenger.user_id,
                                                "boarding_pass",
                                                passenger.flight_id
                                              )
                                            }
                                            disabled={
                                              !selectedFiles[passenger.user_id]
                                                ?.boarding_pass || uploadLoading
                                            }
                                          >
                                            {uploadLoading
                                              ? "Uploading..."
                                              : "Upload"}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </>
                  ) : (
                    <p className="text-gray-500">
                      No passenger information available
                    </p>
                  )}
                </div>
              </div>

              {/* Check-in Steps Tab */}
              <div
                id="checkinSteps"
                className={`tab-content ${
                  activeTab === "checkinSteps" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-4">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-bold">Check-in Steps</h2>
                    {browserUseStepsData.length > 0 && (
                      <button
                        className="btn btn-sm bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 rounded px-3 py-1 flex items-center gap-1"
                        onClick={() => copyToClipboard(JSON.stringify(browserUseStepsData, null, 2))}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                        </svg>
                        Copy Browser Use Steps
                      </button>
                    )}
                  </div>

                  {ticketData?.check_in_steps &&
                  ticketData.check_in_steps.length > 0 ? (
                    <div className="space-y-3">
                      {ticketData.check_in_steps.map((step, index) => (
                        <div
                          key={index}
                          className="border border-gray-200 rounded-lg p-3"
                        >
                          <div className="flex justify-between items-start">
                            <div>
                              <h3 className="text-base font-medium">
                                {step.eventName}
                              </h3>
                              <p className="text-xs text-gray-500">
                                {new Date(step.date).toLocaleString()}
                              </p>
                            </div>
                            <div className="text-xs text-gray-500">
                              {step.metaData &&
                                (typeof step.metaData === 'object' && Object.keys(step.metaData).length > 0) ? (
                                  <div className="mt-1">
                                    <h4 className="font-medium text-xs mb-1">
                                      Metadata:
                                    </h4>
                                    <div className="space-y-0.5">
                                      {Object.entries(step.metaData).map(
                                        ([key, value]) => (
                                          <div
                                            key={key}
                                            className="flex justify-between text-xs"
                                          >
                                            <span className="font-medium">
                                              {key}:
                                            </span>
                                            <span>
                                              {typeof value === 'object'
                                                ? JSON.stringify(value)
                                                : String(value)}
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                ) : step.metaData ? (
                                  <div className="mt-1">
                                    <h4 className="font-medium text-xs mb-1">
                                      Metadata:
                                    </h4>
                                    <div className="space-y-0.5">
                                      <div className="text-xs">
                                        {typeof step.metaData === 'string'
                                          ? step.metaData
                                          : JSON.stringify(step.metaData)}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-gray-500 text-sm">
                      No check-in steps available
                    </p>
                  )}
                </div>
              </div>

              {/* Ticket Documents Tab */}
              <div
                id="ticketDocuments"
                className={`tab-content ${
                  activeTab === "ticketDocuments" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-6">
                  {/* Single Row Upload Section */}
                  <div className="flex items-center gap-4 mb-6 border-b pb-6 flex-wrap">
                    <h2 className="text-lg font-bold">Ticket Documents</h2>
                    
                    {/* Document Type Selection */}
                    <div className="flex items-center gap-2">
                      <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                        Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={selectedDocumentType}
                        onChange={(e) => setSelectedDocumentType(e.target.value)}
                        className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      >
                        <option value="">Select</option>
                        <option value="Boarding_Pass">Boarding Pass</option>
                        <option value="E_Ticket">E-Ticket</option>
                      </select>
                    </div>
                    
                    {/* File Input */}
                    <div className="relative">
                      <input
                        type="file"
                        id="ticket-document"
                        className="hidden"
                        onChange={(e) =>
                          handleFileChange(
                            e,
                            ticketData?.user_id,
                            "ticket_document"
                          )
                        }
                        accept=".pdf,.png,.jpg,.jpeg"
                      />
                      <label
                        htmlFor="ticket-document"
                        className="btn btn-outline flex items-center justify-center cursor-pointer text-sm px-4 py-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                        Choose File
                      </label>
                    </div>
                    
                    {/* Upload Button */}
                    <button
                      className="btn btn-primary flex items-center justify-center text-sm px-4 py-2"
                      onClick={() => {
                        console.log("Upload button clicked");
                        console.log("ticketData:", ticketData);
                        console.log("user_id:", ticketData?.user_id);
                        console.log("flight_data:", ticketData?.flight_data);
                        console.log("flight_data length:", ticketData?.flight_data?.length);
                        console.log("selectedFiles:", selectedFiles);

                        // Check if user_id exists
                        if (!ticketData?.user_id) {
                          console.log("Error: user_id is missing");
                          showToastMessage("Error: User ID is missing", "error");
                          return;
                        }

                        // Check if file is selected
                        if (!selectedFiles[ticketData.user_id]?.ticket_document) {
                          console.log("No file selected");
                          showToastMessage("Please select a file first", "error");
                          return;
                        }

                        // Check if document type is selected
                        if (!selectedDocumentType) {
                          console.log("No document type selected");
                          showToastMessage("Please select a document type first", "error");
                          return;
                        }

                        if (ticketData?.flight_data && ticketData.flight_data.length > 0) {
                          console.log("Flight data exists");
                          console.log("Using first flight ID:", ticketData.flight_data[0].id);
                          // Always use the first flight ID, regardless of how many flights there are
                          handleUpload(
                            ticketData.user_id,
                            "ticket_document",
                            ticketData.flight_data[0].id
                          );
                        } else {
                          console.log("No flight data case");
                          // If no flight data, proceed with null as before
                          handleUpload(
                            ticketData.user_id,
                            "ticket_document",
                            null
                          );
                        }
                      }}
                      disabled={
                        !selectedFiles[ticketData?.user_id]
                          ?.ticket_document || uploadLoading || !selectedDocumentType
                      }
                    >
                      {uploadLoading ? "Uploading..." : "Upload"}
                    </button>
                  </div>

                  {ticketData?.ticket_documents &&
                  ticketData.ticket_documents.length > 0 ? (
                    <div className="grid grid-cols-1 gap-6">
                      {ticketData.ticket_documents.map((document, index) => (
                        <div
                          key={index}
                          className="border border-gray-200 rounded-lg p-6 shadow-sm"
                        >
                          <div className="flex justify-between items-start mb-4">
                            <div>
                              <h3 className="font-semibold text-lg mb-1">
                                {document.document_name ||
                                  `Document ${index + 1}`}
                              </h3>
                              <p className="text-gray-500 text-sm">E-Ticket</p>
                            </div>
                            <div>
                              {/* Only show download button in header for non-PDF files */}
                              {!document.document_url?.toLowerCase().endsWith(".pdf") && (
                                <a
                                  href={document.document_url || "#"}
                                  download
                                  className="btn btn-sm btn-primary"
                                >
                                  Download
                                </a>
                              )}
                              {document.document_id && (
                                <button
                                  className={`btn btn-sm btn-danger ${!document.document_url?.toLowerCase().endsWith(".pdf") ? "ml-2" : ""} bg-red-50 text-red-600 border border-red-200 hover:bg-red-100`}
                                  onClick={() => {
                                    setDocumentToDelete(document);
                                    setShowDeleteDocumentConfirmation(true);
                                  }}
                                >
                                  Delete
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="mt-4 border rounded-md overflow-hidden">
                            {document.document_url ? (
                              document.document_url
                                .toLowerCase()
                                .endsWith(".pdf") ? (
                                <div className="flex flex-col">
                                  <div className="h-96 w-full">
                                    <object
                                      data={document.document_url + '#toolbar=1&navpanes=1&view=FitH'}
                                      type="application/pdf"
                                      width="100%"
                                      height="100%"
                                      className="border-b border-gray-200"
                                    >
                                      <p className="text-center py-4 text-gray-600">
                                        Your browser doesn't support embedded PDFs.
                                        <a
                                          href={document.document_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-blue-600 hover:text-blue-800"
                                        >
                                          Click here to view the PDF
                                        </a>
                                      </p>
                                    </object>
                                  </div>
                                  <div className="flex justify-end p-3 bg-gray-50">
                                    <a
                                      href={document.document_url}
                                      download
                                      className="btn btn-sm btn-primary"
                                    >
                                      Download
                                    </a>
                                  </div>
                                </div>
                              ) : document.document_url
                                  .toLowerCase()
                                  .match(/\.(jpg|jpeg|png|gif)$/) ? (
                                <div className="flex justify-center bg-gray-50 p-4">
                                  <div className="relative w-full max-w-2xl">
                                    <img
                                      src={document.document_url}
                                      alt="Document Preview"
                                      className="w-full h-auto max-h-96 object-contain rounded-md"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgZmlsbD0iI2YzZjRmNiIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LWZhbWlseT0ic2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNnB4IiBmaWxsPSIjOWNhM2FmIj5JbWFnZSBub3QgYXZhaWxhYmxlPC90ZXh0Pjwvc3ZnPg==";
                                      }}
                                    />
                                    <div className="absolute bottom-4 right-4">
                                      <a
                                        href={document.document_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="bg-white text-blue-600 hover:text-blue-800 px-4 py-2 rounded-md shadow-sm text-sm font-medium inline-flex items-center"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-4 w-4 mr-2"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                                          <path d="M5 5a2 2 0 00-3 3v6a2 2 0 110 4v3a2 2 0 002 2h10a2 2 0 002-2v-3a2 2 0 110-4V5z" />
                                        </svg>
                                        View Full Size
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex justify-center py-6 bg-gray-50">
                                  <div className="text-center">
                                    <div className="mb-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-10 w-10 text-gray-400 mx-auto"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M4 4a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM9 7v2.25A2.25 2.25 0 002 10.5H1a.75.75 0 00-.75.75v1.5a.75.75 0 001.5.75h2A2.25 2.25 0 005 10.5v-1.5a.75.75 0 00-.75-.75h-.5a.75.75 0 00-.75.75v1.5a.75.75 0 001.5.75H9z"
                                        />
                                      </svg>
                                    </div>
                                    <p className="text-gray-600">
                                      Document preview not available
                                    </p>
                                    <a
                                      href={document.document_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-600 hover:text-blue-800 text-sm mt-2 inline-block"
                                    >
                                      Click here to open document
                                    </a>
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="flex justify-center py-6 bg-gray-50">
                                <div className="text-center">
                                  <p className="text-gray-600">
                                    Document URL not available
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>
                      <p className="text-gray-500 mb-4">
                        No documents available
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* User Details Tab */}
              <div
                id="userDetails"
                className={`tab-content ${
                  activeTab === "userDetails" ? "active" : ""
                }`}
              >
                <div className="bg-white rounded-lg shadow-sm p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">User Information</h2>
                    {!editingUserDetails &&
                      ticketData?.userData &&
                      ticketData.userData.length > 0 && (
                        <button
                          className="btn btn-sm btn-primary flex items-center gap-1"
                          onClick={startEditingUserDetails}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                          Edit User Details
                        </button>
                      )}
                  </div>

                  {ticketData?.userData && ticketData.userData.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <div className="mb-6">
                          <h3 className="text-lg font-semibold mb-4">
                            Personal Details
                          </h3>
                          <div className="space-y-3">
                            {editingUserDetails ? (
                              // Edit mode - Personal Details
                              <>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    First Name
                                  </label>
                                  <input
                                    type="text"
                                    name="firstName"
                                    value={userFormData.firstName}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Last Name
                                  </label>
                                  <input
                                    type="text"
                                    name="lastName"
                                    value={userFormData.lastName}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Gender
                                  </label>
                                  <select
                                    name="gender"
                                    value={userFormData.gender}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                  </select>
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Date of Birth
                                  </label>
                                  <input
                                    type="date"
                                    name="dob"
                                    value={userFormData.dob}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                              </>
                            ) : (
                              // View mode - Personal Details
                              <>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    First Name
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].firstName || "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Last Name
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].lastName || "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Gender
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].gender || "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Date of Birth
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].dob || "N/A"}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="mb-6">
                          <h3 className="text-lg font-semibold mb-4">
                            Contact
                          </h3>
                          <div className="space-y-3">
                            {editingUserDetails ? (
                              // Edit mode - Contact
                              <>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Country Code
                                  </label>
                                  <input
                                    type="text"
                                    name="countryCode"
                                    value={userFormData.countryCode}
                                    onChange={handleUserInputChange}
                                    placeholder="+91"
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Phone Number
                                  </label>
                                  <input
                                    type="text"
                                    name="phoneNumber"
                                    value={userFormData.phoneNumber}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                              </>
                            ) : (
                              // View mode - Contact
                              <>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md mb-2">
                                  <p className="text-sm text-gray-500">
                                    Country Code
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0]?.mobileNumber?.countryCode || "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Phone Number
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0]?.mobileNumber?.mobileNumber || "N/A"}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <div>
                          <h3 className="text-lg font-semibold mb-4">
                            Identification
                          </h3>
                          <div className="space-y-3">
                            {editingUserDetails ? (
                              // Edit mode - Identification
                              <>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Passport Number
                                  </label>
                                  <input
                                    type="text"
                                    name="passport"
                                    value={userFormData.passport}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Nationality
                                  </label>
                                  <input
                                    type="text"
                                    name="nationality"
                                    value={userFormData.nationality}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="p-3 bg-gray-50 rounded-md">
                                  <label className="block text-sm text-gray-500 mb-1">
                                    Passport Expiry
                                  </label>
                                  <input
                                    type="date"
                                    name="passport_expiry"
                                    value={userFormData.passport_expiry}
                                    onChange={handleUserInputChange}
                                    className="border border-gray-300 rounded p-2 w-full"
                                  />
                                </div>
                                <div className="flex space-x-3 mt-4">
                                  <button
                                    className="btn btn-primary flex-1 py-2"
                                    onClick={updateUserDetails}
                                    disabled={uploadLoading}
                                  >
                                    {uploadLoading
                                      ? "Saving..."
                                      : "Save Changes"}
                                  </button>
                                  <button
                                    className="btn btn-outline flex-1 py-2"
                                    onClick={cancelEditingUserDetails}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </>
                            ) : (
                              // View mode - Identification
                              <>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    ID Type
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].idType ||
                                      "Passport"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Passport Number
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].userDocument
                                      ?.passport ||
                                      ticketData.userData[0].idNumber ||
                                      "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Nationality
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].userDocument
                                      ?.nationality ||
                                      ticketData.userData[0].nationality ||
                                      "N/A"}
                                  </p>
                                </div>
                                <div className="flex justify-between p-3 bg-gray-50 rounded-md">
                                  <p className="text-sm text-gray-500">
                                    Passport Expiry
                                  </p>
                                  <p className="font-medium">
                                    {ticketData.userData[0].userDocument
                                      ?.passport_expiry || "N/A"}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="text-gray-500">
                      No user information available
                    </p>
                  )}
                </div>
              </div>

              {/* Passengers Tab */}
              <div
                id="passengers"
                className={`tab-content ${activeTab === "passengers" ? "active" : ""}`}
              >
                <PassengerDetails
                  passengers={ticketData?.pax_data || []}
                  onUpdatePassenger={handleUpdatePassenger}
                  onDeletePassenger={handleDeletePassengerFromDetails}
                  onRefresh={handleRefreshTicketData}
                />
                {/* DEBUG: Log pax_data structure */}
                {console.log('=== DEBUG: pax_data being passed to PassengerDetails ===', ticketData?.pax_data)}
              </div>

              {/* User Preferences Tab */}
              <div
                id="userPreferences"
                className={`tab-content ${activeTab === "userPreferences" ? "active" : ""}`}
              >
                <UserPreferences
                  userId={ticketData?.user_id || user_id}
                  active={activeTab === "userPreferences"}
                  checkInPreference={ticketData?.checkInPreference}
                />
              </div>
            </div>
          </div>

          {/* Right sidebar with ticket information */}
          <div className="w-80 p-3 border-l bg-white overflow-y-auto">
            <div className="sticky top-0">


              {/* Cancelled Ticket Message */}
              {ticketData?.is_cancelled && (
                <div className="mb-2 p-2 bg-red-50 border border-red-200 rounded-md">
                  <p className="text-red-600 font-medium text-xs">This ticket has been cancelled</p>
                </div>
              )}

              {/* Check-in Status Section */}
              <div className="mb-4">
                <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <span className="text-xs font-medium text-gray-700">
                        Check-in Status
                      </span>
                      <span
                        className={`${getStatusTailwindClasses(
                          ticketData?.checkin_status?.toLowerCase() || ""
                        )} block mt-1 py-1 px-2 text-xs w-fit rounded-md border`}
                      >
                        {statusLabel(ticketData?.checkin_status)}
                      </span>
                    </div>
                  </div>

                  <div className="mt-4 space-y-3 text-sm">
                    <div>
                      <p className="text-xs uppercase text-gray-500 font-semibold">
                        Sub-status
                      </p>
                      <p className="font-medium text-gray-900">
                        {subStatusLabel(ticketData?.checkin_sub_status)}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs uppercase text-gray-500 font-semibold">
                        Message
                      </p>
                      <p className="font-medium text-gray-900 break-words">
                        {ticketData?.checkin_message
                          ? ticketData.checkin_message
                          : "—"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Ticket Information Fields */}
              <div className="space-y-2">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">PNR:</p>
                  <div className="flex items-center">
                    {editingPnr ? (
                      <>
                        <input
                          type="text"
                          value={pnrValue}
                          onChange={(e) => setPnrValue(e.target.value)}
                          className="mr-2 p-1 border border-gray-300 rounded"
                          placeholder="Enter PNR"
                        />
                        <button
                          className="text-green-600 hover:text-green-800 mr-1"
                          onClick={updatePnr}
                          disabled={uploadLoading}
                          title="Save PNR"
                        >
                          {uploadLoading ? "..." : "✓"}
                        </button>
                        <button
                          className="text-red-600 hover:text-red-800"
                          onClick={() => {
                            setEditingPnr(false);
                            setPnrValue(ticketData?.pnr || "");
                          }}
                          title="Cancel"
                        >
                          ✕
                        </button>
                      </>
                    ) : (
                      <>
                        <span className="mr-1 font-medium text-xs">
                          {ticketData?.pnr || ""}
                        </span>
                        <button
                          className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                          onClick={() => copyToClipboard(ticketData?.pnr || "")}
                          title="Copy PNR"
                        >
                          <ClipboardCopyIcon className="h-3 w-3" />
                        </button>
                        <button
                          className="edit-btn hover:bg-gray-100 rounded-full p-1"
                          onClick={() => {
                            setEditingPnr(true);
                            setPnrValue(ticketData?.pnr || "");
                          }}
                          title="Edit PNR"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    Last Name:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-xs">
                      {ticketData?.pax_data?.[0]?.last_name || ""}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(
                          ticketData?.pax_data?.[0]?.last_name || ""
                        )
                      }
                      title="Copy Last Name"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>

                {/* Country Code */}
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    Country Code:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-xs">
                      {ticketData?.userData?.[0]?.mobileNumber?.countryCode || "N/A"}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(
                          ticketData?.userData?.[0]?.mobileNumber?.countryCode || ""
                        )
                      }
                      title="Copy Country Code"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>

                {/* Phone Number */}
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    Phone Number:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-xs">
                      {ticketData?.userData?.[0]?.mobileNumber?.mobileNumber || "N/A"}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(
                          ticketData?.userData?.[0]?.mobileNumber?.mobileNumber || ""
                        )
                      }
                      title="Copy Phone Number"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    Email:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-right truncate max-w-[120px] text-xs">
                      {ticketData?.userData?.[0]?.emails?.[0] || ""}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(
                          ticketData?.userData?.[0]?.emails?.[0] || ""
                        )
                      }
                      title="Copy Email"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    User ID:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-xs">
                      {ticketData?.userData?.[0]?.userId || ""}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(ticketData?.userData?.[0]?.userId || "")
                      }
                      title="Copy User ID"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>

                <div className="flex items-center justify-between p-2 bg-gray-50 rounded border border-gray-100 hover:border-gray-200 transition-colors">
                  <p className="text-xs font-medium text-gray-700 w-20">
                    Ticket ID:
                  </p>
                  <div className="flex items-center">
                    <span className="mr-1 font-medium text-xs">
                      {ticketData?.ticket_id || ""}
                    </span>
                    <button
                      className="copy-btn hover:bg-gray-100 rounded-full p-0.5"
                      onClick={() =>
                        copyToClipboard(ticketData?.ticket_id || "")
                      }
                      title="Copy Ticket ID"
                    >
                      <ClipboardCopyIcon className="h-3 w-3" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Schedule Check-in and Trigger Button */}
              <div className="mt-4">
                <div className="flex flex-col space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Hours before departure
                    </label>
                    <Input
                      type="number"
                      value={scheduledHours}
                      onChange={(e) => setScheduledHours(e.target.value)}
                      min="1"
                      max="168"
                      placeholder="Hours before departure"
                      className="w-full"
                    />
                  </div>

                  <button
                    className="btn btn-secondary w-full flex items-center justify-center gap-2 py-3 shadow-sm hover:shadow text-base mt-2"
                    onClick={handleTriggerBrowserUser}
                    disabled={triggerBrowserLoading || (scheduledHours && parseInt(scheduledHours) < 1)}
                  >
                    {triggerBrowserLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                        Triggering...
                      </>
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          {scheduledHours && parseInt(scheduledHours) > 0 ? (
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                          ) : (
                            <>
                              <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                              <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                            </>
                          )}
                        </svg>
                        {scheduledHours && parseInt(scheduledHours) > 0 ? "Schedule Check-In" : "Initiate Check-In"}
                      </>
                    )}
                  </button>
                  <div className="relative" ref={notificationMenuRef}>
                    <button
                      className="btn btn-primary w-full flex items-center justify-center gap-2 py-3 shadow-sm hover:shadow text-base"
                      onClick={handleNotificationMenuClick}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                      </svg>
                      Send Notification
                      <span
                        className={`transition-transform duration-200 ${
                          showNotificationMenu ? "rotate-180" : ""
                        }`}
                      >
                        ▼
                      </span>
                    </button>
                    {showNotificationMenu && (
                      <div className="absolute right-0 bottom-full mb-2 w-full bg-white rounded-lg shadow-lg notification-dropdown border border-gray-200 overflow-hidden z-50">
                        <div className="py-1">
                          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                            <h3 className="font-medium text-gray-700">
                              Select Notification Type
                            </h3>
                          </div>
                          <NotificationOption
                            status="failed"
                            title="Failed Check-in"
                            description="Send notification about failed check-in"
                            onClick={() => setShowReasonDialog(true)}
                            previewImage={NOTIFICATION_PREVIEW_IMAGES['FAILED_CHECKIN']}
                          />
                          <NotificationOption
                            status="completed"
                            title="Successful Check-in"
                            description="Notify about successful check-in"
                            onClick={() => sendNotification("SUCCESSFUL_CHECKIN")}
                            previewImage={NOTIFICATION_PREVIEW_IMAGES['SUCCESSFUL_CHECKIN']}
                          />
                          <NotificationOption
                            status="in_progress"
                            title="Seat Purchase"
                            description="Confirm seat purchase"
                            onClick={() => setShowSeatPurchaseForm(!showSeatPurchaseForm)}
                            previewImage={NOTIFICATION_PREVIEW_IMAGES['SEAT_PURCHASE']}
                          />
                          <NotificationOption
                            status="scheduled"
                            title="CheckIn opt in message"
                            description="Send check-in opt-in notification"
                            onClick={() => sendNotification("OPT_IN_CHECKIN")}
                            previewImage={NOTIFICATION_PREVIEW_IMAGES['OPT_IN_CHECKIN']}
                          />
                          <NotificationOption
                            status="completed"
                            title="Send Boarding Pass"
                            description="Send boarding pass notification"
                            onClick={() => sendNotification("BOARDING_PASS")}
                            previewImage={NOTIFICATION_PREVIEW_IMAGES['BOARDING_PASS']}
                            isLast
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-2 relative" ref={statusMenuRef}>
                    <button
                      className="btn btn-primary w-full flex items-center justify-center gap-2 py-3 shadow-sm hover:shadow text-base"
                      onClick={handleStatusMenuClick}
                      disabled={uploadLoading}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                      {uploadLoading ? (
                        <span className="flex items-center">
                          <svg
                            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Updating...
                        </span>
                      ) : (
                        "Update Check-in Status"
                      )}
                      <span
                        className={`transition-transform duration-200 ${
                          showStatusMenu ? "rotate-180" : ""
                        }`}
                      >
                        ▼
                      </span>
                    </button>
                    {showStatusMenu && (
                      <div className="absolute right-0 bottom-full mb-2 w-full bg-white rounded-lg shadow-lg notification-dropdown border border-gray-200 overflow-hidden z-50">
                        <div className="py-1">
                          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                            <h3 className="font-medium text-gray-700">
                              Select Status
                            </h3>
                          </div>
                          {STATUS_OPTIONS.map(({ value, label }, index) => (
                            <button
                              key={value}
                              className={`flex items-center w-full px-4 py-3 text-sm text-left hover:bg-gray-100 transition-colors ${
                                index < STATUS_OPTIONS.length - 1 ? "border-b border-gray-100" : ""
                              }`}
                              onClick={() => handleStatusSelection(value)}
                            >
                              <div className={`w-2 h-2 rounded-full ${getStatusIndicatorColor(value)} mr-3`}></div>
                              <div>
                                <div className={`font-medium ${getStatusTextColor(value)}`}>{label}</div>
                                <div className="text-xs text-gray-500 mt-0.5">{value}</div>
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Sync Email Button - Moved to Bottom */}
                  <button
                    className="btn btn-secondary w-full flex items-center justify-center gap-1 py-2 shadow-sm hover:shadow text-xs mt-4"
                    onClick={() => {
                      setEmailSyncLoading(true);
                      fetch(
                        `${ADMIN_API_BASE_URL}/emailSyncForBoardingPass?ticketId=${ticketData.ticket_id}&userId=${user_id}`,
                        {
                          method: "GET",
                          headers: {
                            authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjQ1MCwiaWF0IjoxNzQzMTYwNDA2fQ.pIsqGqCnK98W5b8B4GUs6SSetmSiHg8v_XBrNSMagZ0`,
                          },
                        }
                      )
                        .then((response) => response.json())
                        .then((data) => {
                          setDialogMessage(
                            data.message || "Email synced successfully"
                          );
                          setDialogType("success");
                          setOpenDialog(true);
                          setEmailSyncLoading(false);
                        })
                        .catch((error) => {
                          console.error("Error syncing email:", error);
                          setDialogMessage(
                            "Error syncing email. Please try again."
                          );
                          setDialogType("error");
                          setOpenDialog(true);
                          setEmailSyncLoading(false);
                        });
                    }}
                    disabled={emailSyncLoading}
                  >
                    {emailSyncLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"></div>
                        Syncing...
                      </>
                    ) : (
                      <>
                        <EnvelopeClosedIcon className="h-5 w-5" />
                        Sync Email
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Toast Notification */}
          <div id="toast" className={`toast ${showToast ? "show" : ""}`}>
            <div
              id="toast-message"
              className={`text-${
                toastType === "success" ? "green" : "red"
              }-600`}
            >
              {toastMessage}
            </div>
          </div>

          {/* Delete Passenger Dialog */}
          {showDeleteConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">Confirm Delete</h2>
                <p className="mb-6">
                  Are you sure you want to delete this passenger? This action
                  cannot be undone.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    className="btn btn-outline"
                    onClick={() => setShowDeleteConfirmation(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary bg-red-500 hover:bg-red-600"
                    onClick={() => {
                      handleDeletePassenger(passengerToDelete);
                      setShowDeleteConfirmation(false);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Delete Ticket Dialog */}
          {showDeleteTicketConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">Confirm Delete Ticket</h2>
                <p className="mb-6">
                  Are you sure you want to delete this ticket? This action
                  cannot be undone and will remove all associated data.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    className="btn btn-outline"
                    onClick={() => setShowDeleteTicketConfirmation(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary bg-red-500 hover:bg-red-600"
                    onClick={handleDeleteTicket}
                    disabled={uploadLoading}
                  >
                    {uploadLoading ? "Deleting..." : "Delete Ticket"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Cancel Ticket Dialog */}
          {showCancelTicketConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">Confirm Cancel Ticket</h2>
                <p className="mb-6">
                  Are you sure you want to cancel this ticket? This action will mark the ticket as cancelled.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    className="btn btn-outline"
                    onClick={() => setShowCancelTicketConfirmation(false)}
                  >
                    No, Keep Ticket
                  </button>
                  <button
                    className="btn btn-primary bg-yellow-500 hover:bg-yellow-600 text-white"
                    onClick={handleCancelTicket}
                    disabled={uploadLoading}
                  >
                    {uploadLoading ? "Cancelling..." : "Yes, Cancel Ticket"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Delete Document Dialog */}
          {showDeleteDocumentConfirmation && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">Confirm Delete Document</h2>
                <p className="mb-6">
                  Are you sure you want to delete this document? This action cannot be undone.
                </p>
                <div className="flex justify-end space-x-4">
                  <button
                    className="btn btn-outline"
                    onClick={() => {
                      setShowDeleteDocumentConfirmation(false);
                      setDocumentToDelete(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary bg-red-500 hover:bg-red-600 text-white"
                    onClick={handleDeleteDocument}
                    disabled={uploadLoading}
                  >
                    {uploadLoading ? "Deleting..." : "Delete Document"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Reason Input Dialog */}
          {showReasonDialog && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">
                  Enter Reason for Failed Check-in
                </h2>
                <textarea
                  className="w-full p-2 border border-gray-300 rounded-md mb-4"
                  rows="4"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Enter reason for failed check-in..."
                ></textarea>
                <div className="flex justify-end space-x-4">
                  <button
                    onClick={() => {
                      setShowReasonDialog(false);
                      setReason("");
                    }}
                    className="btn btn-outline"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      sendNotification("FAILED_CHECKIN", reason);
                      setShowReasonDialog(false);
                      setReason("");
                    }}
                    disabled={!reason.trim()}
                    className="btn btn-primary"
                  >
                    Send Notification
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Response Dialog */}
          {openDialog && dialogType !== "reason-input" && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold mb-4">Notification</h2>
                <p className="mb-6">{dialogMessage}</p>
                <div className="flex justify-end">
                  <button
                    className="btn btn-primary"
                    onClick={() => setOpenDialog(false)}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Seat Purchase Form */}
          {showSeatPurchaseForm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full relative">
                <button
                  onClick={() => setShowSeatPurchaseForm(false)}
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
                <h2 className="text-xl font-bold mb-4">Seat Purchase</h2>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Seat Number
                    </label>
                    <input
                      type="text"
                      value={seatNumber}
                      onChange={(e) => setSeatNumber(e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Currency
                    </label>
                    <input
                      type="text"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Amount
                    </label>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                      required
                    />
                  </div>
                  <div className="flex space-x-3 mt-6">
                    <button
                      onClick={() => setShowSeatPurchaseForm(false)}
                      className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        if (seatNumber && currency && amount) {
                          sendNotification(
                            "SUCCESSFUL_SEAT_PURCHASE_WITH_PAYMENT"
                          );
                          setShowSeatPurchaseForm(false);
                        } else {
                          setDialogMessage("Please fill all required fields");
                          setDialogType("error");
                          setOpenDialog(true);
                        }
                      }}
                      className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                      Confirm Purchase
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Global Flight Selection Dialog */}
      {console.log("showFlightSelection:", showFlightSelection)}
      {console.log("ticketData?.flight_data:", ticketData?.flight_data)}
      {showFlightSelection && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full relative">
            <button
              onClick={() => setShowFlightSelection(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <h3 className="text-xl font-bold mb-4">
              Select Flight
            </h3>
            <div className="space-y-4">
              {ticketData?.flight_data?.map((flight) => (
                <button
                  key={flight.id}
                  className="w-full p-3 rounded-lg hover:bg-gray-50 flex items-center justify-between"
                  onClick={() => handleFlightSelect(flight.id)}
                >
                  <div>
                    <h4 className="font-semibold">
                      Flight {flight.flight_number}
                    </h4>
                    <p className="text-sm text-gray-500">
                      {flight.departure_data.airport_iata} → {" "}
                      {flight.arrival_data.airport_iata}
                    </p>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10 10.586l7.293-7.293a1 1 0 011.414 1.414l-8 8a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Email Text Modal */}
      {/* Status Update Dialog */}
      <RadixDialog
        open={showStatusUpdateDialog}
        onOpenChange={setShowStatusUpdateDialog}
        title={`Update Status to ${selectedStatusForUpdate ? statusLabel(selectedStatusForUpdate) : ""}`}
        description="Please provide check-in sub status and message (optional)"
        maxWidth="md"
        footer={
          <div className="flex gap-3">
            <RadixButton
              variant="outline"
              onClick={() => {
                setShowStatusUpdateDialog(false);
                setSelectedStatusForUpdate(null);
                setCheckinSubStatusValue("");
                setCheckinMessageValue("");
                setSelectedMissingInfoMessages([]);
              }}
            >
              Cancel
            </RadixButton>
            <RadixButton
              variant="default"
              onClick={handleManualStatusUpdate}
              disabled={uploadLoading}
            >
              {uploadLoading ? "Updating..." : "Update Status"}
            </RadixButton>
          </div>
        }
      >
        <div className="space-y-4">
          <CheckInStatusPresets
            disabled={uploadLoading}
            onSelect={(preset) => {
              setSelectedStatusForUpdate(preset.status);
              setCheckinSubStatusValue(preset.subStatus);
              setCheckinMessageValue(preset.message);
              setSelectedMissingInfoMessages([]);
            }}
          />
          {/* Check-in Sub Status */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Check-in Sub Status <span className="text-gray-400 text-xs">(Optional)</span>
            </label>
            <select
              className="w-full border border-gray-300 rounded-md text-sm p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={checkinSubStatusValue || ""}
              onChange={(e) => handleSubStatusFieldChange(e.target.value)}
            >
              <option value="">None</option>
              {subStatusOptions(selectedStatusForUpdate, checkinSubStatusValue).map((option) => (
                <option key={option.value} value={option.value} disabled={option.invalid}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Check-in Message */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Check-in Message <span className="text-gray-400 text-xs">(Optional)</span>
            </label>
            {isMissingInfoSelected ? (
              <div className="space-y-2">
                <div className="border border-gray-300 rounded-md p-2 min-h-[100px] max-h-[200px] overflow-y-auto">
                  {MISSING_INFO_MESSAGE_OPTIONS.length === 0 ? (
                    <p className="text-sm text-gray-500">No options available</p>
                  ) : (
                    <div className="space-y-2">
                      {MISSING_INFO_MESSAGE_OPTIONS.map((option) => (
                        <label
                          key={option}
                          className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 p-2 rounded"
                        >
                          <input
                            type="checkbox"
                            checked={selectedMissingInfoMessages.includes(option)}
                            onChange={() => handleMissingInfoMessageChange(option)}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
                {selectedMissingInfoMessages.length > 0 && (
                  <p className="text-xs text-gray-500">
                    Selected: {selectedMissingInfoMessages.join(", ")}
                  </p>
                )}
              </div>
            ) : (
              <Input
                value={checkinMessageValue || ""}
                onChange={(e) => setCheckinMessageValue(e.target.value)}
                placeholder="Enter check-in message (optional)"
                className="w-full"
              />
            )}
          </div>
        </div>
      </RadixDialog>

      <RadixDialog
        open={showEmailTextModal}
        onOpenChange={setShowEmailTextModal}
        title="Email Text Data"
        description="Raw API response from the parse-text endpoint"
        maxWidth="lg"
        footer={
          <RadixButton
            variant="outline"
            onClick={() => setShowEmailTextModal(false)}
          >
            Close
          </RadixButton>
        }
      >
        <div className="space-y-4">
          {parsedEmailTextData && (
            <>
              <div className="flex justify-between items-center">
                <h4 className="font-medium text-gray-900">API Response</h4>
                <button
                  onClick={() => copyToClipboard(JSON.stringify(parsedEmailTextData, null, 2))}
                  className="text-blue-600 hover:text-blue-800 text-sm flex items-center"
                >
                  <ClipboardCopyIcon className="h-4 w-4 mr-1" />
                  Copy
                </button>
              </div>
              <div className="bg-gray-50 p-4 rounded-md border border-gray-200 max-h-96 overflow-auto">
                <pre className="text-xs whitespace-pre-wrap break-all text-gray-800">
                  {JSON.stringify(parsedEmailTextData, null, 2)}
                </pre>
              </div>
            </>
          )}
          {!parsedEmailTextData && (
            <div className="text-center py-8 text-gray-500">
              No data available
            </div>
          )}
        </div>
      </RadixDialog>
    </MainLayout>
  );
};

/**
 * Notification Option Component with Hover Preview Tooltip
 * @param {Object} props - Component props
 * @param {string} props.status - Status type for color indicator
 * @param {string} props.title - Notification title
 * @param {string} props.description - Notification description
 * @param {Function} props.onClick - Click handler
 * @param {string} props.previewImage - Path to preview image
 * @param {boolean} props.isLast - Whether this is the last option (no border)
 */
const NotificationOption = React.memo(({
  status,
  title,
  description,
  onClick,
  previewImage,
  isLast = false
}) => {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div
      className={`flex items-center w-full px-4 py-3 text-sm hover:bg-gray-100 transition-colors ${
        isLast ? '' : 'border-b border-gray-100'
      }`}
    >
      <button
        className="flex-1 flex items-center text-left"
        onClick={onClick}
      >
        <div className={`w-2 h-2 rounded-full ${getStatusIndicatorColor(status)} mr-3 flex-shrink-0`}></div>
        <div className="flex-1 min-w-0">
          <div className={`font-medium ${getStatusTextColor(status)}`}>
            {title}
          </div>
          <div className="text-xs text-gray-500 mt-0.5">
            {description}
          </div>
        </div>
      </button>
      {/* Info Icon with Hover Preview Tooltip */}
      <div
        className="relative ml-2 flex-shrink-0"
        onMouseEnter={(e) => {
          e.stopPropagation();
          setShowPreview(true);
        }}
        onMouseLeave={(e) => {
          e.stopPropagation();
          setShowPreview(false);
        }}
      >
        <button
          type="button"
          className="p-1 rounded-md hover:bg-gray-200 transition-colors"
          onClick={(e) => e.stopPropagation()}
        >
          <InfoCircledIcon
            className="w-4 h-4 text-gray-400 hover:text-blue-500 transition-colors cursor-help"
          />
        </button>
        {/* Hover Preview Tooltip - Fixed Position */}
        {showPreview && (
          <div
            className="fixed z-[9999]"
            style={{
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
            onMouseEnter={() => setShowPreview(true)}
            onMouseLeave={() => setShowPreview(false)}
          >
            <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-3 w-80">
              <div className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1.5">
                <InfoCircledIcon className="w-3.5 h-3.5 text-blue-500" />
                {title} - Preview
              </div>
              <div className="rounded-lg border border-gray-100 overflow-hidden bg-gray-50">
                <img
                  src={previewImage}
                  alt={`${title} preview`}
                  className="w-full h-auto max-h-[70vh] object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden flex-col items-center justify-center h-48 text-gray-400">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mb-2 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span className="text-sm">Preview not available</span>
                </div>
              </div>
            </div>
            {/* Arrow pointing left */}
            <div
              className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2 w-0 h-0"
              style={{
                borderTop: '8px solid transparent',
                borderBottom: '8px solid transparent',
                borderRight: '8px solid white',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
});

NotificationOption.displayName = 'NotificationOption';

export default CheckInDetailsPage;
